'use strict';

/* ═══════════════════════════════════════════════════════════════
   DRAWING TOOL ENGINE
   ═══════════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function(){
(function(){

var $=function(id){return document.getElementById(id)};

/* ── Translations & config from Blade ── */
var L=window.__DW.L;
var SHAPE_CATS=window.__DW.SHAPE_CATS;
var SHAPE_NAMES=window.__DW.SHAPE_NAMES;

/* ── Constants ── */
var CANVAS_W=1200, CANVAS_H=800;
var INTERNAL_SIZE; // off-screen canvases are always INTERNAL_SIZE x INTERNAL_SIZE to preserve data on orientation switch
// Memory-saver mode: Sentry TIMBRICA-FRONTEND-3W (Android 7.1.1 WebView
// Chrome 119, 1 GB RAM cohort) — saveState() takes 3 full-canvas
// getImageData snapshots per undo frame (draw + shape + pixel layers),
// roughly 8 MB × 3 = 24 MB per snapshot at 1200×800×RGBA. With MAX_UNDO=30
// the worst-case undo stack reaches ~720 MB which OOMs WebView. We
// detect low-memory devices via navigator.deviceMemory + the WebView UA
// heuristic and shrink MAX_UNDO to 5 + cap each getImageData call in a
// try/catch with shift-and-retry on RangeError. Result: tool works on
// 1 GB Android (limited undo) instead of crashing on every action.
function _detectLowMem() {
    try {
        var dm = navigator.deviceMemory;
        if (typeof dm === 'number' && dm < 4) return true;
    } catch (_) {}
    try {
        var ua = (navigator.userAgent || '').toLowerCase();
        var androidVer = ua.match(/android (\d+)/i);
        if (androidVer && parseInt(androidVer[1], 10) < 8) return true;
    } catch (_) {}
    return false;
}
var IS_LOW_MEM = _detectLowMem();
var MAX_UNDO = IS_LOW_MEM ? 5 : 30;
var COLORS=['#000000','#ffffff','#ef4444','#f97316','#eab308','#22c55e','#06b6d4','#3b82f6','#8b5cf6','#ec4899','#92400e','#6b7280'];

/* ── State ── */
var activeTool='pencil';
var activeColor='#000000';
var brushSize=4;

/* ── Нажим активного пера ─────────────────────────────────────────────────
   До 2026-08-09 этот файл читал `pointerType` только чтобы отличить палец, а
   `pressure` не использовал НИГДЕ: Apple Pencil и перо Wacom рисовали ровно
   такой же ровной линией, как палец. Толщина от нажима — первое, зачем перо
   вообще берут в руки.

   Включаем сами, увидев перо с ПЛАВНЫМ нажимом. Признак «pointerType==='pen'»
   для этого не годится: у пера с выключенным Windows Ink нажим приходит только
   0 или 1, и множитель по нему давал бы не штрих переменной толщины, а рваную
   линию — хуже, чем было. Мышь тоже отпадает: у неё pressure всегда ровно 0.5.
   Пока плавного нажима не видели, весь код рисования идёт прежним путём —
   один путь на пачку точек, без изменений в поведении для большинства. */
var penPressureSeen=false;

function notePressure(e){
    if(!e||e.pointerType!=='pen')return;
    var pr=e.pressure;
    if(typeof pr!=='number')return;
    if(pr>0.001&&pr<0.999&&Math.abs(pr-0.5)>0.02)penPressureSeen=true;
}

/** Толщина штриха под нажим. Показатель 0.7 делает лёгкие касания заметнее,
    чем линейная зависимость: у пера полезный диапазон живёт в нижней трети. */
function penWidth(e){
    if(!penPressureSeen||!e||e.pointerType!=='pen')return brushSize;
    var pr=Math.max(0,Math.min(1,typeof e.pressure==='number'?e.pressure:0.5));
    return Math.max(0.35,brushSize*(0.15+0.85*Math.pow(pr,0.7)));
}
var brushOpacity=1;
var textOpacity=1;
var isDrawing=false;
var lastX=0, lastY=0;
var points=[];
var undoStack=[], redoStack=[];
var recentColors=[];
var pixelMode=false;
var pixelGridSize=64;
var zoomLevel=1, panX=0, panY=0;
var isPanning=false, panStartX=0, panStartY=0;
var shapeMode=null; // active shape from catalog
var drawStart=null; // {x,y} for line/rect/circle
var dirty=true;

/* ── Objects (shapes & text as editable objects) ── */
var objects=[];
var nextObjId=1;
var selectedObj=null; // reference to object in objects[]
var dragState=null; // {type:'move'|'resize'|'rotate', startX, startY, origObj:{...}}
var HANDLE_SIZE=8;

/* ── Canvas layers ── */
var displayCanvas=$('display-canvas');
var displayCtx=displayCanvas.getContext('2d');

// Off-screen layers
function makeCanvas(w,h){var c=document.createElement('canvas');c.width=w;c.height=h;return c;}
var bgCanvas=makeCanvas(CANVAS_W,CANVAS_H);
var bgCtx=bgCanvas.getContext('2d');
var shapeCanvas=makeCanvas(CANVAS_W,CANVAS_H);
var shapeCtx=shapeCanvas.getContext('2d',{willReadFrequently:true});
var drawCanvas=makeCanvas(CANVAS_W,CANVAS_H);
var drawCtx=drawCanvas.getContext('2d',{willReadFrequently:true});
var pixelCanvas=makeCanvas(CANVAS_W,CANVAS_H);
var pixelCtx=pixelCanvas.getContext('2d',{willReadFrequently:true});
var previewCanvas=makeCanvas(CANVAS_W,CANVAS_H);
var previewCtx=previewCanvas.getContext('2d');
var objectCanvas=makeCanvas(CANVAS_W,CANVAS_H);
var objectCtx=objectCanvas.getContext('2d');
var strokeCanvas=makeCanvas(CANVAS_W,CANVAS_H);
var strokeCtx=strokeCanvas.getContext('2d');
var strokeOpacity=1; // opacity to apply when compositing strokeCanvas

/* ── Which layers changed, and which are blank ──
   The picture a person makes lives in three layers — drawCanvas (pencil, brush,
   spray, fill, lines, flattened objects), pixelCanvas (pixel mode) and
   shapeCanvas — plus the objects list. The saved work keeps each layer as a PNG
   (see «THE WORK SURVIVES…» below). Every pixel write to a layer bumps its
   revision here, whatever code path made it, so a change re-encodes exactly the
   layers it touched. A layer that was only cleared or erased stays «blank» and is
   saved as no picture at all: shapeCanvas is always blank now (nothing paints on
   it since catalog shapes became objects), the pixel layer until pixel mode is used. */
var LAYER_KEYS=['draw','shape','pixel'];
var LAYER_CANVAS={draw:drawCanvas,shape:shapeCanvas,pixel:pixelCanvas};
var LAYER_CTX={draw:drawCtx,shape:shapeCtx,pixel:pixelCtx};
var layerRev={draw:0,shape:0,pixel:0};
var layerBlank={draw:true,shape:true,pixel:true};
(function watchLayers(){
    var WRITES=['stroke','fill','fillRect','strokeRect','fillText','strokeText','drawImage','putImageData','clearRect'];
    LAYER_KEYS.forEach(function(k){
        var ctx=LAYER_CTX[k];
        WRITES.forEach(function(m){
            var orig=ctx[m];
            if(typeof orig!=='function')return;
            ctx[m]=function(a,b,c,d){
                layerRev[k]++;
                if(m==='clearRect'){
                    var cv=ctx.canvas;
                    if(a<=0&&b<=0&&a+c>=cv.width&&b+d>=cv.height)layerBlank[k]=true;
                }else if(m==='putImageData'||ctx.globalCompositeOperation!=='destination-out'){
                    layerBlank[k]=false;   // erasing a blank layer leaves it blank
                }
                return orig.apply(ctx,arguments);
            };
        });
    });
})();
function _blankNow(){return {draw:layerBlank.draw,shape:layerBlank.shape,pixel:layerBlank.pixel};}

/* ── Init ── */
function initCanvas(){
    var isMobile=window.innerWidth<=768;
    if(isMobile){CANVAS_W=600;CANVAS_H=800;$('sel-orientation').value='portrait';}
    INTERNAL_SIZE=Math.max(CANVAS_W,CANVAS_H);
    // Off-screen canvases are square (max dim) so orientation switch preserves all data
    [bgCanvas,shapeCanvas,drawCanvas,pixelCanvas,previewCanvas,objectCanvas,strokeCanvas].forEach(function(c){
        c.width=INTERNAL_SIZE;c.height=INTERNAL_SIZE;
    });
    bgCtx.fillStyle='#ffffff';
    bgCtx.fillRect(0,0,INTERNAL_SIZE,INTERNAL_SIZE);
    // Setup display canvas
    sizeDisplayCanvas();
    dirty=true;
    compositeAndRender();
}

function sizeDisplayCanvas(){
    var area=$('canvas-area');
    if(!area)return;
    var aw=area.clientWidth-32, ah=area.clientHeight-32;
    var baseScale=Math.min(aw/CANVAS_W,ah/CANVAS_H,1);
    var dw=Math.round(CANVAS_W*baseScale*zoomLevel);
    var dh=Math.round(CANVAS_H*baseScale*zoomLevel);
    var dpr=window.devicePixelRatio||1;
    displayCanvas.style.width=dw+'px';
    displayCanvas.style.height=dh+'px';
    displayCanvas.width=Math.round(dw*dpr);
    displayCanvas.height=Math.round(dh*dpr);
    displayCtx.setTransform(dpr,0,0,dpr,0,0);
    var wrap=$('canvas-wrap');
    wrap.style.aspectRatio='auto';
    wrap.style.maxWidth='none';
    wrap.style.maxHeight='none';
    wrap.style.width=dw+'px';
    wrap.style.height=dh+'px';
    // When zoomed, center canvas if smaller than viewport, else allow scroll from top-left
    if(dw<=aw && dh<=ah){
        wrap.style.margin='auto';
    }else{
        wrap.style.margin='16px';
    }
    dirty=true;
}

/* ═══════════════════════════════════════════════════════════════
   OBJECTS — render all objects onto objectCanvas
   ═══════════════════════════════════════════════════════════════ */
function renderObjects(){
    objectCtx.clearRect(0,0,CANVAS_W,CANVAS_H);
    objects.forEach(function(obj){renderOneObject(objectCtx,obj);});
}

function flattenObjects(){
    if(!objects.length) return;
    saveState();
    objects.forEach(function(obj){renderOneObject(drawCtx,obj);});
    objects=[];
    selectedObj=null;
    objectCtx.clearRect(0,0,CANVAS_W,CANVAS_H);
    previewCtx.clearRect(0,0,CANVAS_W,CANVAS_H);
    markDirty();
}

function renderOneObject(ctx,obj){
    ctx.save();
    ctx.translate(obj.x,obj.y);
    if(obj.rotation) ctx.rotate(obj.rotation*Math.PI/180);
    if(obj.flipH) ctx.scale(-1,1);
    if(obj.flipV) ctx.scale(1,-1);
    ctx.globalAlpha=obj.opacity;
    if(obj.type==='shape'){
        var shape=obj.shape;
        var sz=obj.size;
        var vb=(shape.viewBox||'0 0 100 100').split(' ').map(Number);
        var sx=sz/vb[2], sy=sz/vb[3];
        var s=Math.min(sx,sy);
        ctx.translate(-sz/2,-sz/2);
        ctx.scale(s,s);
        ctx.strokeStyle=obj.color;
        ctx.lineWidth=2/s;
        ctx.lineCap='round';ctx.lineJoin='round';
        (shape.paths||[]).forEach(function(pathStr){
            var p2=new Path2D(pathStr);
            /* Fill closed paths with white so flood-fill sees a boundary */
            if(/[zZ]\s*$/.test(pathStr)){
                ctx.fillStyle='#ffffff';
                ctx.fill(p2);
            }
            ctx.stroke(p2);
        });
    }else if(obj.type==='text'){
        ctx.font='bold '+obj.fontSize+'px '+obj.fontFamily;
        ctx.fillStyle=obj.color;
        ctx.textBaseline='middle';
        var lines=(obj.text||'').split('\n');
        var totalH=lines.length*obj.fontSize*1.2;
        lines.forEach(function(line,i){
            ctx.fillText(line,-obj.width/2, -totalH/2 + i*obj.fontSize*1.2 + obj.fontSize*0.6);
        });
    }
    ctx.restore();
}

function getObjectBounds(obj){
    var hw,hh;
    if(obj.type==='shape'){
        hw=obj.size/2; hh=obj.size/2;
    }else if(obj.type==='text'){
        hw=obj.width/2; hh=obj.height/2;
    }else{hw=50;hh=50;}
    return {x:obj.x-hw, y:obj.y-hh, w:hw*2, h:hh*2};
}

/* ── Selection handles ── */
function renderSelection(){
    previewCtx.clearRect(0,0,CANVAS_W,CANVAS_H);
    if(!selectedObj) return;
    var b=getObjectBounds(selectedObj);
    var pad=6;
    var bx=b.x-pad, by=b.y-pad, bw=b.w+pad*2, bh=b.h+pad*2;

    previewCtx.save();
    // Rotate the selection box if object is rotated
    if(selectedObj.rotation){
        previewCtx.translate(selectedObj.x, selectedObj.y);
        previewCtx.rotate(selectedObj.rotation*Math.PI/180);
        previewCtx.translate(-selectedObj.x, -selectedObj.y);
    }
    // Dashed border
    previewCtx.setLineDash([5,4]);
    previewCtx.strokeStyle='rgba(56,189,248,0.7)';
    previewCtx.lineWidth=1.5;
    previewCtx.strokeRect(bx,by,bw,bh);
    previewCtx.setLineDash([]);
    // 8 handles: corners + midpoints
    var hs=HANDLE_SIZE;
    var handles=getHandlePositions(bx,by,bw,bh);
    handles.forEach(function(h){
        previewCtx.fillStyle='#fff';
        previewCtx.fillRect(h.x-hs/2,h.y-hs/2,hs,hs);
        previewCtx.strokeStyle='rgba(56,189,248,0.9)';
        previewCtx.lineWidth=1.5;
        previewCtx.strokeRect(h.x-hs/2,h.y-hs/2,hs,hs);
    });
    // Rotation handle (top center, offset above)
    var rotX=bx+bw/2, rotY=by-20;
    previewCtx.beginPath();
    previewCtx.moveTo(bx+bw/2,by);
    previewCtx.lineTo(rotX,rotY);
    previewCtx.strokeStyle='rgba(56,189,248,0.5)';
    previewCtx.lineWidth=1;
    previewCtx.stroke();
    previewCtx.beginPath();
    previewCtx.arc(rotX,rotY,5,0,Math.PI*2);
    previewCtx.fillStyle='rgba(56,189,248,0.9)';
    previewCtx.fill();
    previewCtx.strokeStyle='#fff';
    previewCtx.lineWidth=1.5;
    previewCtx.stroke();
    previewCtx.restore();
    markDirty();
}

function getHandlePositions(bx,by,bw,bh){
    return [
        {x:bx,y:by,cursor:'nwse-resize',type:'tl'},
        {x:bx+bw,y:by,cursor:'nesw-resize',type:'tr'},
        {x:bx,y:by+bh,cursor:'nesw-resize',type:'bl'},
        {x:bx+bw,y:by+bh,cursor:'nwse-resize',type:'br'},
        {x:bx+bw/2,y:by,cursor:'ns-resize',type:'tc'},
        {x:bx+bw/2,y:by+bh,cursor:'ns-resize',type:'bc'},
        {x:bx,y:by+bh/2,cursor:'ew-resize',type:'ml'},
        {x:bx+bw,y:by+bh/2,cursor:'ew-resize',type:'mr'},
    ];
}

/* ── Hit testing ── */
function hitTestObject(px,py){
    // Iterate in reverse (topmost first)
    for(var i=objects.length-1;i>=0;i--){
        var obj=objects[i];
        var b=getObjectBounds(obj);
        // If rotated, transform point into object's local space
        var lx=px,ly=py;
        if(obj.rotation){
            var rad=-obj.rotation*Math.PI/180;
            var dx=px-obj.x, dy=py-obj.y;
            lx=obj.x + dx*Math.cos(rad)-dy*Math.sin(rad);
            ly=obj.y + dx*Math.sin(rad)+dy*Math.cos(rad);
        }
        if(lx>=b.x && lx<=b.x+b.w && ly>=b.y && ly<=b.y+b.h){
            return obj;
        }
    }
    return null;
}

function hitTestHandle(px,py){
    if(!selectedObj) return null;
    var b=getObjectBounds(selectedObj);
    var pad=6;
    var bx=b.x-pad, by=b.y-pad, bw=b.w+pad*2, bh=b.h+pad*2;
    // Transform point if rotated
    var lx=px,ly=py;
    if(selectedObj.rotation){
        var rad=-selectedObj.rotation*Math.PI/180;
        var dx=px-selectedObj.x, dy=py-selectedObj.y;
        lx=selectedObj.x + dx*Math.cos(rad)-dy*Math.sin(rad);
        ly=selectedObj.y + dx*Math.sin(rad)+dy*Math.cos(rad);
    }
    // Check rotation handle
    var rotX=bx+bw/2, rotY=by-20;
    if(Math.sqrt((lx-rotX)*(lx-rotX)+(ly-rotY)*(ly-rotY))<12){
        return {type:'rotate'};
    }
    // Check resize handles
    var handles=getHandlePositions(bx,by,bw,bh);
    var hs=HANDLE_SIZE+4;
    for(var i=0;i<handles.length;i++){
        if(Math.abs(lx-handles[i].x)<hs && Math.abs(ly-handles[i].y)<hs){
            return {type:'resize',handle:handles[i].type,cursor:handles[i].cursor};
        }
    }
    return null;
}

function selectObject(obj){
    selectedObj=obj;
    renderSelection();
    updateSidebarPanels();
}

function deselectObject(){
    selectedObj=null;
    previewCtx.clearRect(0,0,CANVAS_W,CANVAS_H);
    markDirty();
    updateSidebarPanels();
}

/* ── Object transforms ── */
function saveObjectsSnapshot(){
    return objects.map(function(o){return JSON.parse(JSON.stringify(o));});
}
function restoreObjectsSnapshot(snap){
    // Restore shape references (JSON lost them)
    objects=snap.map(function(o){
        if(o.type==='shape' && o._shapeId){
            o.shape=findShapeById(o._shapeId)||o.shape;
        }
        return o;
    });
    selectedObj=null;
    renderObjects();
    renderSelection();
}

function findShapeById(id){
    var cats=window.__DRAWING_SHAPES||{};
    for(var cat in cats){
        for(var i=0;i<cats[cat].length;i++){
            if(cats[cat][i].id===id) return cats[cat][i];
        }
    }
    return null;
}

/* ── Compositing ── */
function compositeAndRender(){
    if(!dirty)return;
    renderObjects();
    var dw=parseFloat(displayCanvas.style.width);
    var dh=parseFloat(displayCanvas.style.height);
    displayCtx.clearRect(0,0,dw,dh);
    displayCtx.imageSmoothingEnabled=zoomLevel<3;
    displayCtx.drawImage(bgCanvas,0,0,CANVAS_W,CANVAS_H,0,0,dw,dh);
    displayCtx.drawImage(shapeCanvas,0,0,CANVAS_W,CANVAS_H,0,0,dw,dh);
    displayCtx.drawImage(drawCanvas,0,0,CANVAS_W,CANVAS_H,0,0,dw,dh);
    if(isDrawing&&strokeOpacity<1){
        displayCtx.globalAlpha=strokeOpacity;
        displayCtx.drawImage(strokeCanvas,0,0,CANVAS_W,CANVAS_H,0,0,dw,dh);
        displayCtx.globalAlpha=1;
    }
    displayCtx.drawImage(objectCanvas,0,0,CANVAS_W,CANVAS_H,0,0,dw,dh);
    displayCtx.drawImage(pixelCanvas,0,0,CANVAS_W,CANVAS_H,0,0,dw,dh);
    displayCtx.drawImage(previewCanvas,0,0,CANVAS_W,CANVAS_H,0,0,dw,dh);
    // Pixel grid overlay
    if(pixelMode){
        var cellW=dw/pixelGridSize, cellH=dh/pixelGridSize;
        displayCtx.strokeStyle='rgba(128,128,128,0.2)';
        displayCtx.lineWidth=0.5;
        for(var i=1;i<pixelGridSize;i++){
            displayCtx.beginPath();displayCtx.moveTo(i*cellW,0);displayCtx.lineTo(i*cellW,dh);displayCtx.stroke();
            displayCtx.beginPath();displayCtx.moveTo(0,i*cellH);displayCtx.lineTo(dw,i*cellH);displayCtx.stroke();
        }
    }
    dirty=false;
}

// every visible change comes through here — the saved work asks, once the change has
// settled, whether it was a change of the work (queueCommit, «THE WORK SURVIVES…»)
function markDirty(){dirty=true;requestAnimationFrame(compositeAndRender);queueCommit();}

/* ── Coordinate conversion ── */
function canvasCoords(e){
    var rect=displayCanvas.getBoundingClientRect();
    var sx=Math.max(0,Math.min(CANVAS_W,(e.clientX-rect.left)/rect.width*CANVAS_W));
    var sy=Math.max(0,Math.min(CANVAS_H,(e.clientY-rect.top)/rect.height*CANVAS_H));
    return {x:sx, y:sy};
}

/* ═══════════════════════════════════════════════════════════════
   UNDO / REDO (includes objects)
   ═══════════════════════════════════════════════════════════════ */
function _safeGetImageData(ctx) {
    // Returns the ImageData OR null on RangeError-class allocation
    // failure. Called from saveState/currentStateSnap so the caller can
    // shed older undo frames and retry. Closes Sentry 3W class on
    // Android-WebView 1 GB cohort.
    try { return ctx.getImageData(0, 0, CANVAS_W, CANVAS_H); }
    catch (e) {
        if (e && (e.name === 'RangeError' || /memory|allocation/i.test(e.message || ''))) return null;
        throw e;
    }
}
function _captureLayers() {
    var draw = _safeGetImageData(drawCtx);
    var shape = _safeGetImageData(shapeCtx);
    var pixel = _safeGetImageData(pixelCtx);
    return (draw && shape && pixel) ? { draw: draw, shape: shape, pixel: pixel, blank: _blankNow() } : null;
}
function saveState(){
    var layers = _captureLayers();
    if (!layers) {
        // OOM on this snapshot. Drop the oldest 60% of undo history and
        // try once more. If still failing we silently skip the snapshot
        // — user loses one undo step but the tool keeps working.
        while (undoStack.length > Math.max(1, Math.floor(undoStack.length * 0.4))) undoStack.shift();
        layers = _captureLayers();
        if (!layers) return;
    }
    undoStack.push({
        draw: layers.draw, shape: layers.shape, pixel: layers.pixel, blank: layers.blank,
        objects:saveObjectsSnapshot()
    });
    if(undoStack.length>MAX_UNDO)undoStack.shift();
    redoStack=[];
    updateUndoButtons();
}

function currentStateSnap(){
    // May return null on low-memory OOM — caller (redo path) should
    // treat null as "snapshot unavailable, skip pushing onto redoStack".
    var layers = _captureLayers();
    if (!layers) return null;
    return {
        draw: layers.draw, shape: layers.shape, pixel: layers.pixel, blank: layers.blank,
        objects:saveObjectsSnapshot()
    };
}

function applyState(state){
    var was=_blankNow();
    drawCtx.putImageData(state.draw,0,0);
    shapeCtx.putImageData(state.shape,0,0);
    pixelCtx.putImageData(state.pixel,0,0);
    // a layer blank before and blank in the snapshot is blank still (putImageData marks it painted)
    if(state.blank) LAYER_KEYS.forEach(function(k){ if(was[k]&&state.blank[k]) layerBlank[k]=true; });
    if(state.objects) restoreObjectsSnapshot(state.objects);
    markDirty();
}

function undo(){
    if(!undoStack.length)return;
    var snap = currentStateSnap();
    if (snap) redoStack.push(snap);  // null on low-mem OOM → undo still works, just no redo of THIS state
    applyState(undoStack.pop());
    updateUndoButtons();
}

function redo(){
    if(!redoStack.length)return;
    var snap = currentStateSnap();
    if (snap) undoStack.push(snap);  // null on low-mem OOM → redo still works
    applyState(redoStack.pop());
    updateUndoButtons();
}

function updateUndoButtons(){
    $('btn-undo').disabled=!undoStack.length;
    $('btn-redo').disabled=!redoStack.length;
}

/* ═══════════════════════════════════════════════════════════════
   DRAWING ENGINE — Pointer Events
   ═══════════════════════════════════════════════════════════════ */
function setupDrawing(){
    var canvas=displayCanvas;
    canvas.style.touchAction='none';

    canvas.addEventListener('pointerdown', onPointerDown);
    canvas.addEventListener('pointermove', onPointerMove);
    canvas.addEventListener('pointerup', onPointerUp);
    canvas.addEventListener('pointerleave', function(e){$('cursor-dot').style.display='none';});
    canvas.addEventListener('lostpointercapture', function(){touchCount=0;isPanning=false;});
    canvas.addEventListener('wheel', onWheel, {passive:false});
    canvas.addEventListener('contextmenu', function(e){e.preventDefault();});
    // Allow starting strokes from just outside the canvas (coords clamp to edge)
    var area=$('canvas-area');
    area.addEventListener('pointerdown', function(e){
        if(e.target===canvas||e.target.closest('.dw-text-wrap')||e.target.closest('.dw-zoom-bar'))return;
        onPointerDown(e);
    });
    area.addEventListener('pointermove', function(e){if(isDrawing)onPointerMove(e);});
    area.addEventListener('pointerup', function(e){if(isDrawing)onPointerUp(e);});
    // Catch pointerup anywhere (mouse released outside window/area)
    document.addEventListener('pointerup', function(e){if(isDrawing)onPointerUp(e);});

    // Keyboard shortcuts
    document.addEventListener('keydown', function(e){
        if(e.target.tagName==='INPUT'||e.target.tagName==='TEXTAREA'||e.target.tagName==='SELECT')return;
        if(e.target.isContentEditable&&!(e.ctrlKey||e.metaKey))return;
        var kl=window.__keyLetter?window.__keyLetter(e):String(e.key||'').toLowerCase();
        if((e.ctrlKey||e.metaKey)&&kl==='z'){
            if(e.target.isContentEditable){commitTextOverlay();}
            e.preventDefault();if(e.shiftKey)redo();else undo();
        }
        if((e.ctrlKey||e.metaKey)&&kl==='y'){
            if(e.target.isContentEditable){commitTextOverlay();}
            e.preventDefault();redo();
        }
        // Delete selected object
        if((e.key==='Delete'||e.key==='Backspace')&&selectedObj&&activeTool==='select'){
            if(e.target.isContentEditable)return;
            e.preventDefault();
            deleteSelectedObject();
        }
        // Escape to deselect
        if(e.key==='Escape'&&selectedObj&&activeTool==='select'){
            e.preventDefault();
            deselectObject();
        }
        // Ctrl+D to duplicate
        if((e.ctrlKey||e.metaKey)&&kl==='d'&&selectedObj&&activeTool==='select'){
            e.preventDefault();
            duplicateSelectedObject();
        }
    });
}

var touchCount=0;

function onPointerDown(e){
    e.preventDefault();
    // Capture pointer so moves/up fire even outside canvas
    try{displayCanvas.setPointerCapture(e.pointerId);}catch(ex){}
    if(e.pointerType==='touch'){
        touchCount++;
        if(touchCount>=2){isPanning=true;panStartX=e.clientX;panStartY=e.clientY;return;}
    }
    var p=canvasCoords(e);

    /* ── SELECT TOOL ── */
    if(activeTool==='select'){
        // Check handle first (resize/rotate)
        var handle=hitTestHandle(p.x,p.y);
        if(handle&&selectedObj){
            isDrawing=true;
            if(handle.type==='rotate'){
                dragState={type:'rotate',startAngle:Math.atan2(p.y-selectedObj.y,p.x-selectedObj.x),origRotation:selectedObj.rotation||0};
                saveState();
            }else{
                dragState={type:'resize',handle:handle.handle,startX:p.x,startY:p.y,
                    origX:selectedObj.x,origY:selectedObj.y,
                    origSize:selectedObj.type==='shape'?selectedObj.size:0,
                    origW:selectedObj.width||0,origH:selectedObj.height||0,
                    origFontSize:selectedObj.fontSize||24};
                saveState();
            }
            return;
        }
        // Check object hit
        var hit=hitTestObject(p.x,p.y);
        if(hit){
            selectObject(hit);
            isDrawing=true;
            dragState={type:'move',startX:p.x,startY:p.y,origX:hit.x,origY:hit.y};
            return;
        }
        // Click on empty: deselect
        deselectObject();
        return;
    }

    if(activeTool==='eyedropper'){
        pickColor(p.x, p.y);
        return;
    }

    if(activeTool==='filters'){
        return;
    }

    if(activeTool==='shapes'&&shapeMode){
        placeShapeDirectly(p.x, p.y);
        return;
    }

    if(activeTool==='fill'){
        if(objects.length) flattenObjects(); else saveState();
        floodFill(Math.round(p.x), Math.round(p.y), activeColor, brushOpacity);
        addUsedColor(activeColor);
        markDirty();
        return;
    }

    if(activeTool==='text'){
        if(activeTextOverlay) commitTextOverlay();
        createTextOverlay(p);
        return;
    }

    // Shape tools (line, rect, circle)
    if(activeTool==='line'||activeTool==='rect'||activeTool==='circle'){
        drawStart={x:p.x,y:p.y};
        isDrawing=true;
        return;
    }

    // Spray tool
    if(activeTool==='spray'){
        isDrawing=true;
        saveState();
        addUsedColor(activeColor);
        sprayAt(p.x, p.y);
        return;
    }

    // Freeform drawing
    isDrawing=true;
    lastX=p.x;lastY=p.y;
    points=[{x:p.x,y:p.y}];

    if(pixelMode&&(activeTool==='pencil'||activeTool==='brush'||activeTool==='spray')){
        saveState();
        addUsedColor(activeColor);
        drawPixel(p.x,p.y);
        return;
    }

    saveState();
    if(activeTool!=='eraser') addUsedColor(activeColor);

    // For pencil/brush with opacity < 1: draw on strokeCanvas at full alpha,
    // composite with desired opacity during render and on pointerUp.
    // This prevents overlapping segments from accumulating opacity.
    var useStrokeLayer=(activeTool==='pencil'||activeTool==='brush')&&brushOpacity<1;

    var ctx=useStrokeLayer?strokeCtx:drawCtx;
    if(useStrokeLayer){
        strokeCtx.clearRect(0,0,INTERNAL_SIZE,INTERNAL_SIZE);
        strokeOpacity=activeTool==='brush'?Math.max(0.05,brushOpacity*0.3):brushOpacity;
    }
    notePressure(e);
    ctx.lineCap='round';
    ctx.lineJoin='round';
    ctx.lineWidth=penWidth(e);

    if(activeTool==='eraser'){
        // Erase from all layers — drawCanvas, shapeCanvas, pixelCanvas + paint white on bg
        ctx.globalCompositeOperation='destination-out';
        ctx.globalAlpha=1;
        shapeCtx.globalCompositeOperation='destination-out';
        shapeCtx.lineCap='round';shapeCtx.lineJoin='round';
        shapeCtx.lineWidth=brushSize;shapeCtx.globalAlpha=1;
        shapeCtx.beginPath();shapeCtx.moveTo(p.x,p.y);shapeCtx.lineTo(p.x+0.1,p.y+0.1);shapeCtx.stroke();
        pixelCtx.globalCompositeOperation='destination-out';
        pixelCtx.lineCap='round';pixelCtx.lineJoin='round';
        pixelCtx.lineWidth=brushSize;pixelCtx.globalAlpha=1;
        pixelCtx.beginPath();pixelCtx.moveTo(p.x,p.y);pixelCtx.lineTo(p.x+0.1,p.y+0.1);pixelCtx.stroke();
        bgCtx.globalCompositeOperation='source-over';
        bgCtx.strokeStyle='#ffffff';
        bgCtx.lineCap='round';bgCtx.lineJoin='round';
        bgCtx.lineWidth=brushSize;bgCtx.globalAlpha=1;
        bgCtx.beginPath();bgCtx.moveTo(p.x,p.y);bgCtx.lineTo(p.x+0.1,p.y+0.1);bgCtx.stroke();
    }else if(activeTool==='brush'){
        ctx.globalCompositeOperation='source-over';
        ctx.globalAlpha=useStrokeLayer?1:Math.max(0.05, brushOpacity*0.3);
        ctx.strokeStyle=activeColor;
        ctx.lineCap='round';
        ctx.lineJoin='round';
    }else{
        ctx.globalCompositeOperation='source-over';
        ctx.globalAlpha=useStrokeLayer?1:brushOpacity;
        ctx.strokeStyle=activeColor;
    }

    ctx.beginPath();
    ctx.moveTo(p.x,p.y);
    ctx.lineTo(p.x+0.1,p.y+0.1);
    ctx.stroke();
    markDirty();
}

function onPointerMove(e){
    e.preventDefault();

    // Cursor preview (use main event position)
    updateCursorPreview(e);

    if(isPanning){return;}

    var p=canvasCoords(e);

    /* ── SELECT TOOL drag ── */
    if(activeTool==='select'&&isDrawing&&dragState&&selectedObj){
        var ds=dragState;
        if(ds.type==='move'){
            // «Undo» for a move: the state before it, taken at the first real movement
            // (rotate and resize take theirs on press; a bare click to select must not
            // add a step). Until 01.10.2026 a move could not be undone at all.
            if(!ds.saved&&(p.x!==ds.startX||p.y!==ds.startY)){ds.saved=true;saveState();}
            selectedObj.x=ds.origX+(p.x-ds.startX);
            selectedObj.y=ds.origY+(p.y-ds.startY);
        }else if(ds.type==='resize'){
            var dx=p.x-ds.startX, dy=p.y-ds.startY;
            if(selectedObj.type==='shape'){
                var delta=0;
                if(ds.handle==='br') delta=Math.max(dx,dy);
                else if(ds.handle==='tl') delta=-Math.max(dx,dy);
                else if(ds.handle==='tr') delta=Math.max(-dy,dx);
                else if(ds.handle==='bl') delta=Math.max(dy,-dx);
                else if(ds.handle==='mr'||ds.handle==='ml') delta=ds.handle==='mr'?dx:-dx;
                else if(ds.handle==='tc'||ds.handle==='bc') delta=ds.handle==='bc'?dy:-dy;
                selectedObj.size=Math.max(20, ds.origSize+delta*2);
            }else if(selectedObj.type==='text'){
                var scaleF=1;
                if(ds.handle==='br') scaleF=Math.max(0.3, 1+(Math.max(dx,dy))/(ds.origH||100));
                else if(ds.handle==='tl') scaleF=Math.max(0.3, 1+(-Math.max(dx,dy))/(ds.origH||100));
                else if(ds.handle==='bc'||ds.handle==='tc') scaleF=Math.max(0.3, 1+(ds.handle==='bc'?dy:-dy)/(ds.origH||100));
                else if(ds.handle==='mr'||ds.handle==='ml') scaleF=Math.max(0.3, 1+(ds.handle==='mr'?dx:-dx)/(ds.origW||100));
                else scaleF=Math.max(0.3, 1+(dx+dy)*0.5/(ds.origH||100));
                selectedObj.fontSize=Math.round(Math.max(8, ds.origFontSize*scaleF));
                measureTextObject(selectedObj);
            }
        }else if(ds.type==='rotate'){
            var angle=Math.atan2(p.y-selectedObj.y,p.x-selectedObj.x);
            var diff=(angle-ds.startAngle)*180/Math.PI;
            selectedObj.rotation=((ds.origRotation+diff)%360+360)%360;
            var snaps=[0,90,180,270,360];
            for(var si=0;si<snaps.length;si++){
                if(Math.abs(selectedObj.rotation-snaps[si])<5) selectedObj.rotation=snaps[si]%360;
            }
        }
        renderSelection();
        markDirty();
        return;
    }

    if(!isDrawing)return;

    // Shape preview
    if(drawStart&&(activeTool==='line'||activeTool==='rect'||activeTool==='circle')){
        previewCtx.clearRect(0,0,CANVAS_W,CANVAS_H);
        previewCtx.strokeStyle=activeColor;
        previewCtx.lineWidth=brushSize;
        previewCtx.lineCap='round';
        previewCtx.globalAlpha=brushOpacity;
        previewCtx.beginPath();
        if(activeTool==='line'){
            previewCtx.moveTo(drawStart.x,drawStart.y);
            previewCtx.lineTo(p.x,p.y);
        }else if(activeTool==='rect'){
            previewCtx.rect(drawStart.x,drawStart.y,p.x-drawStart.x,p.y-drawStart.y);
        }else{
            var rx=Math.abs(p.x-drawStart.x)/2, ry=Math.abs(p.y-drawStart.y)/2;
            var cx=drawStart.x+(p.x-drawStart.x)/2, cy=drawStart.y+(p.y-drawStart.y)/2;
            previewCtx.ellipse(cx,cy,rx,ry,0,0,Math.PI*2);
        }
        previewCtx.stroke();
        previewCtx.globalAlpha=1;
        markDirty();
        return;
    }

    // Pixel drawing (eraser excluded — it erases from all layers below)
    if(pixelMode&&(activeTool==='pencil'||activeTool==='brush'||activeTool==='spray')){
        drawPixel(p.x,p.y);
        markDirty();
        return;
    }

    // Use getCoalescedEvents for smooth strokes (fills gaps between pointer events)
    var coalescedEvents;
    if(e.getCoalescedEvents){
        try{coalescedEvents=e.getCoalescedEvents();}catch(ex){}
    }
    if(!coalescedEvents||coalescedEvents.length===0) coalescedEvents=[e];

    // Spray: draw each point individually
    if(activeTool==='spray'){
        for(var ci=0;ci<coalescedEvents.length;ci++){
            var cp=canvasCoords(coalescedEvents[ci]);
            sprayAt(cp.x, cp.y);
            lastX=cp.x;lastY=cp.y;
        }
        markDirty();
        return;
    }

    // Build a single continuous path from all coalesced points
    // (one beginPath + one stroke = uniform opacity, no dotted overlap)
    var useStrokeLayer=(activeTool==='pencil'||activeTool==='brush')&&brushOpacity<1;
    var ctx=useStrokeLayer?strokeCtx:drawCtx;
    var cpts=[];
    for(var ci=0;ci<coalescedEvents.length;ci++){
        var cp=canvasCoords(coalescedEvents[ci]);
        notePressure(coalescedEvents[ci]);
        cp.w=penWidth(coalescedEvents[ci]);
        points.push({x:cp.x,y:cp.y,w:cp.w});
        cpts.push(cp);
    }

    // Перо с плавным нажимом: рисуем посегментно, чтобы толщина шла за нажимом.
    // Отдельная ветка, а не правка общей: у общей вся суть в ОДНОМ пути на
    // пачку точек (так не копится полупрозрачность на стыках), и ломать её
    // ради пера, которого у большинства нет, — плохой размен.
    if(penPressureSeen){
        drawPressureSegments(ctx,cpts,useStrokeLayer);
        var lastP=cpts[cpts.length-1];
        lastX=lastP.x;lastY=lastP.y;
        markDirty();
        return;
    }

    if(activeTool==='eraser'){
        ctx.beginPath();ctx.moveTo(lastX,lastY);
        shapeCtx.beginPath();shapeCtx.moveTo(lastX,lastY);
        pixelCtx.beginPath();pixelCtx.moveTo(lastX,lastY);
        bgCtx.beginPath();bgCtx.moveTo(lastX,lastY);
        for(var ci=0;ci<cpts.length;ci++){
            ctx.lineTo(cpts[ci].x,cpts[ci].y);
            shapeCtx.lineTo(cpts[ci].x,cpts[ci].y);
            pixelCtx.lineTo(cpts[ci].x,cpts[ci].y);
            bgCtx.lineTo(cpts[ci].x,cpts[ci].y);
        }
        ctx.stroke();shapeCtx.stroke();pixelCtx.stroke();bgCtx.stroke();
    }else if(useStrokeLayer){
        // Redraw entire stroke path on strokeCanvas to avoid overlap at segment joins
        strokeCtx.clearRect(0,0,INTERNAL_SIZE,INTERNAL_SIZE);
        strokeCtx.beginPath();
        strokeCtx.moveTo(points[0].x,points[0].y);
        for(var ci=1;ci<points.length;ci++){
            strokeCtx.lineTo(points[ci].x,points[ci].y);
        }
        strokeCtx.stroke();
    }else{
        ctx.beginPath();
        ctx.moveTo(lastX,lastY);
        for(var ci=0;ci<cpts.length;ci++){
            ctx.lineTo(cpts[ci].x,cpts[ci].y);
        }
        ctx.stroke();
    }

    var last=cpts[cpts.length-1];
    lastX=last.x;lastY=last.y;
    markDirty();
}

/**
 * Штрих переменной толщины.
 *
 * Полупрозрачный режим (strokeCanvas) перерисовывает ВЕСЬ штрих заново: слой
 * рисуется при альфе 1 и накладывается один раз, поэтому наложение сегментов
 * внутри слоя ничего не портит — а вот рисовать посегментно прямо в холст с
 * альфой <1 нельзя, стыки потемнеют.
 */
function drawPressureSegments(ctx,cpts,useStrokeLayer){
    if(activeTool==='eraser'){
        var px=lastX,py=lastY;
        for(var i=0;i<cpts.length;i++){
            var w=cpts[i].w;
            ctx.lineWidth=w;shapeCtx.lineWidth=w;pixelCtx.lineWidth=w;bgCtx.lineWidth=w;
            ctx.beginPath();ctx.moveTo(px,py);ctx.lineTo(cpts[i].x,cpts[i].y);ctx.stroke();
            shapeCtx.beginPath();shapeCtx.moveTo(px,py);shapeCtx.lineTo(cpts[i].x,cpts[i].y);shapeCtx.stroke();
            pixelCtx.beginPath();pixelCtx.moveTo(px,py);pixelCtx.lineTo(cpts[i].x,cpts[i].y);pixelCtx.stroke();
            bgCtx.beginPath();bgCtx.moveTo(px,py);bgCtx.lineTo(cpts[i].x,cpts[i].y);bgCtx.stroke();
            px=cpts[i].x;py=cpts[i].y;
        }
        return;
    }
    if(useStrokeLayer){
        strokeCtx.clearRect(0,0,INTERNAL_SIZE,INTERNAL_SIZE);
        for(var k=1;k<points.length;k++){
            strokeCtx.lineWidth=points[k].w||brushSize;
            strokeCtx.beginPath();
            strokeCtx.moveTo(points[k-1].x,points[k-1].y);
            strokeCtx.lineTo(points[k].x,points[k].y);
            strokeCtx.stroke();
        }
        return;
    }
    var sx=lastX,sy=lastY;
    for(var j=0;j<cpts.length;j++){
        ctx.lineWidth=cpts[j].w;
        ctx.beginPath();ctx.moveTo(sx,sy);ctx.lineTo(cpts[j].x,cpts[j].y);ctx.stroke();
        sx=cpts[j].x;sy=cpts[j].y;
    }
}

function onPointerUp(e){
    if(e&&e.pointerType==='touch'){
        touchCount=Math.max(0,touchCount-1);
        if(touchCount<2)isPanning=false;
    }

    if(!isDrawing)return;
    isDrawing=false;

    // End select tool drag
    if(activeTool==='select'&&dragState){
        dragState=null;
        renderSelection();
        markDirty();
        return;
    }

    // Finalize shape tools
    if(drawStart&&(activeTool==='line'||activeTool==='rect'||activeTool==='circle')){
        if(e){
            var p=canvasCoords(e);
            saveState();
            // In pixel mode, draw to a temp canvas then rasterize
            var targetCtx=pixelMode?makeCanvas(CANVAS_W,CANVAS_H).getContext('2d'):drawCtx;
            targetCtx.strokeStyle=activeColor;
            targetCtx.lineWidth=brushSize;
            targetCtx.lineCap='round';
            targetCtx.globalAlpha=brushOpacity;
            targetCtx.beginPath();
            if(activeTool==='line'){
                targetCtx.moveTo(drawStart.x,drawStart.y);
                targetCtx.lineTo(p.x,p.y);
            }else if(activeTool==='rect'){
                targetCtx.rect(drawStart.x,drawStart.y,p.x-drawStart.x,p.y-drawStart.y);
            }else{
                var rx2=Math.abs(p.x-drawStart.x)/2, ry2=Math.abs(p.y-drawStart.y)/2;
                var cx2=drawStart.x+(p.x-drawStart.x)/2, cy2=drawStart.y+(p.y-drawStart.y)/2;
                targetCtx.ellipse(cx2,cy2,rx2,ry2,0,0,Math.PI*2);
            }
            targetCtx.stroke();
            targetCtx.globalAlpha=1;
            if(pixelMode) rasterizeToPixels(targetCtx.canvas);
        }
        previewCtx.clearRect(0,0,CANVAS_W,CANVAS_H);
        drawStart=null;
        addUsedColor(activeColor);
        markDirty();
        return;
    }

    // If we used the stroke layer, composite it onto drawCanvas now
    var useStrokeLayer=(activeTool==='pencil'||activeTool==='brush')&&strokeOpacity<1;
    if(useStrokeLayer){
        drawCtx.globalAlpha=strokeOpacity;
        drawCtx.drawImage(strokeCanvas,0,0);
        drawCtx.globalAlpha=1;
        strokeCtx.clearRect(0,0,INTERNAL_SIZE,INTERNAL_SIZE);
        strokeOpacity=1;
    }

    // Reset composite op
    drawCtx.globalCompositeOperation='source-over';
    drawCtx.globalAlpha=1;
    shapeCtx.globalCompositeOperation='source-over';
    shapeCtx.globalAlpha=1;
    bgCtx.globalCompositeOperation='source-over';
    bgCtx.globalAlpha=1;
    points=[];
    markDirty();
}

/* ── Rasterize vector content to pixel grid ── */
function rasterizeToPixels(sourceCanvas){
    var cellW=CANVAS_W/pixelGridSize, cellH=CANVAS_H/pixelGridSize;
    var srcCtx=sourceCanvas.getContext('2d');
    for(var gy=0;gy<pixelGridSize;gy++){
        for(var gx=0;gx<pixelGridSize;gx++){
            // Sample center of each cell
            var sx=Math.floor(gx*cellW+cellW/2), sy=Math.floor(gy*cellH+cellH/2);
            var d=srcCtx.getImageData(sx,sy,1,1).data;
            if(d[3]>20){ // has visible content
                pixelCtx.fillStyle='rgba('+d[0]+','+d[1]+','+d[2]+','+(d[3]/255).toFixed(2)+')';
                pixelCtx.fillRect(gx*cellW,gy*cellH,cellW,cellH);
            }
        }
    }
}

/* ── Pixel drawing ── */
function drawPixel(x,y){
    var cellW=CANVAS_W/pixelGridSize, cellH=CANVAS_H/pixelGridSize;
    var gx=Math.floor(x/cellW), gy=Math.floor(y/cellH);
    if(gx<0||gy<0||gx>=pixelGridSize||gy>=pixelGridSize)return;
    if(activeTool==='eraser'){
        pixelCtx.clearRect(gx*cellW,gy*cellH,cellW,cellH);
        // Paint white on bg to ensure clean erase
        bgCtx.fillStyle='#ffffff';
        bgCtx.fillRect(gx*cellW,gy*cellH,cellW,cellH);
    }else{
        pixelCtx.fillStyle=activeColor;
        pixelCtx.globalAlpha=brushOpacity;
        pixelCtx.fillRect(gx*cellW,gy*cellH,cellW,cellH);
        pixelCtx.globalAlpha=1;
    }
}

/* ── Spray tool ── */
function sprayAt(x,y){
    var ctx=drawCtx;
    var radius=brushSize*3;
    var density=Math.max(30, brushSize*5);
    ctx.fillStyle=activeColor;
    for(var i=0;i<density;i++){
        var angle=Math.random()*Math.PI*2;
        var r=Math.random()*radius;
        var dx=x+Math.cos(angle)*r;
        var dy=y+Math.sin(angle)*r;
        ctx.globalAlpha=brushOpacity*(0.2+Math.random()*0.5);
        ctx.fillRect(dx,dy,1+Math.random()*1.5,1+Math.random()*1.5);
    }
    ctx.globalAlpha=1;
    markDirty();
}

/* ── Cursor preview ── */
function updateCursorPreview(e){
    var dot=$('cursor-dot');
    if(activeTool==='eyedropper'||activeTool==='text'||activeTool==='shapes'||activeTool==='fill'||activeTool==='filters'||activeTool==='select'){
        dot.style.display='none';return;
    }
    var area=$('canvas-area');
    var rect=area.getBoundingClientRect();
    var sizeMultiplier=activeTool==='spray'?4:1;
    var size=brushSize*sizeMultiplier*(parseFloat(displayCanvas.style.width)/CANVAS_W);
    dot.style.display='block';
    dot.style.width=Math.max(4,size)+'px';
    dot.style.height=Math.max(4,size)+'px';
    dot.style.left=(e.clientX-rect.left+area.scrollLeft-size/2)+'px';
    dot.style.top=(e.clientY-rect.top+area.scrollTop-size/2)+'px';
    dot.style.backgroundColor=activeTool==='eraser'?'rgba(255,255,255,.3)':activeColor+'33';
}

/* ═══════════════════════════════════════════════════════════════
   INLINE TEXT EDITING
   ═══════════════════════════════════════════════════════════════ */
var activeTextOverlay=null;

function createTextOverlay(canvasPos){
    var rect=displayCanvas.getBoundingClientRect();
    var areaRect=$('canvas-area').getBoundingClientRect();
    var scaleX=rect.width/CANVAS_W;
    var scaleY=rect.height/CANVAS_H;
    var fs=parseInt($('sl-font-size').value)||24;
    var ff=$('text-font').value||'sans-serif';
    var screenFs=Math.round(fs*scaleY);
    var area=$('canvas-area');

    // Wrapper (absolute positioned, holds both editable + handle)
    var wrap=document.createElement('div');
    wrap.className='dw-text-wrap';
    wrap.style.left=(rect.left-areaRect.left+area.scrollLeft+canvasPos.x*scaleX)+'px';
    wrap.style.top=(rect.top-areaRect.top+area.scrollTop+canvasPos.y*scaleY-screenFs/2)+'px';

    // Editable div (no handle inside — caret stays clean)
    var div=document.createElement('div');
    div.className='dw-text-overlay';
    div.contentEditable='true';
    div.style.fontSize=screenFs+'px';
    div.style.fontFamily=ff;
    div.style.fontWeight='bold';
    div.style.color=activeColor;
    div.style.opacity=textOpacity;
    div.spellcheck=false;
    wrap.appendChild(div);

    // Resize handle (outside contentEditable)
    var handle=document.createElement('div');
    handle.className='dw-text-handle';
    var resizing=false,resStartX=0,resStartY=0,resStartFs=0,resStartW=0;
    handle.addEventListener('pointerdown',function(ev){
        ev.preventDefault();ev.stopPropagation();
        resizing=true; resStartX=ev.clientX; resStartY=ev.clientY; resStartFs=screenFs;
        resStartW=div.offsetWidth;
        handle.setPointerCapture(ev.pointerId);
    });
    handle.addEventListener('pointermove',function(ev){
        if(!resizing)return;
        var dx=ev.clientX-resStartX, dy=ev.clientY-resStartY;
        div.style.width=Math.max(30,resStartW+dx)+'px';
        div.style.whiteSpace='pre-wrap';div.style.wordBreak='break-word';
        screenFs=Math.max(10,resStartFs+dy);
        div.style.fontSize=screenFs+'px';
        if(activeTextOverlay) activeTextOverlay.fs=Math.round(screenFs/scaleY);
        $('sl-font-size').value=activeTextOverlay.fs;
        $('sl-font-size').dispatchEvent(new Event('input',{bubbles:true}));
        $('font-size-val').textContent=activeTextOverlay.fs+'px';
    });
    handle.addEventListener('pointerup',function(ev){resizing=false;});
    wrap.appendChild(handle);

    div.addEventListener('keydown',function(e){
        if(e.key==='Escape'){commitTextOverlay();e.preventDefault();return;}
        if(e.key==='Enter'){e.preventDefault();document.execCommand('insertLineBreak');return;}
        var kl=window.__keyLetter?window.__keyLetter(e):String(e.key||'').toLowerCase();
        if((e.ctrlKey||e.metaKey)&&(kl==='z'||kl==='y'))return;
        e.stopPropagation();
    });
    wrap.addEventListener('pointerdown',function(e){e.stopPropagation();});

    area.appendChild(wrap);
    div.focus({preventScroll:true});

    activeTextOverlay={el:div,wrap:wrap,x:canvasPos.x,y:canvasPos.y,fs:fs,ff:ff};
}

function commitTextOverlay(){
    if(!activeTextOverlay)return;
    var txt=(activeTextOverlay.el.innerText||'').replace(/\n$/,'');
    var el=activeTextOverlay.el;
    if(txt.trim()){
        saveState();
        var fs=activeTextOverlay.fs;
        var ff=activeTextOverlay.ff;
        // Measure text width
        var tmpCtx=makeCanvas(1,1).getContext('2d');
        tmpCtx.font='bold '+fs+'px '+ff;
        var lines=txt.split('\n');
        var maxW=0;
        lines.forEach(function(line){maxW=Math.max(maxW,tmpCtx.measureText(line).width);});
        var totalH=lines.length*fs*1.2;

        if(pixelMode){
            // Render text to temp canvas, then rasterize to pixel grid
            var tc=makeCanvas(CANVAS_W,CANVAS_H);
            var tctx=tc.getContext('2d');
            tctx.font='bold '+fs+'px '+ff;
            tctx.fillStyle=activeColor;
            tctx.globalAlpha=textOpacity;
            tctx.textBaseline='top';
            for(var i=0;i<lines.length;i++){
                tctx.fillText(lines[i], activeTextOverlay.x, activeTextOverlay.y-fs*0.1+i*fs*1.2);
            }
            rasterizeToPixels(tc);
        } else {
            // Create text object
            var obj={
                id:nextObjId++, type:'text',
                x:activeTextOverlay.x+maxW/2, y:activeTextOverlay.y,
                text:txt, fontSize:fs, fontFamily:ff,
                color:activeColor, opacity:textOpacity,
                width:maxW, height:totalH,
                rotation:0, flipH:false, flipV:false
            };
            objects.push(obj);
            selectObject(obj);
        }
        addUsedColor(activeColor);
        markDirty();
    }
    (activeTextOverlay.wrap||el).remove();
    activeTextOverlay=null;
}

function measureTextObject(obj){
    var tmpCtx=makeCanvas(1,1).getContext('2d');
    tmpCtx.font='bold '+obj.fontSize+'px '+obj.fontFamily;
    var lines=(obj.text||'').split('\n');
    var maxW=0;
    lines.forEach(function(line){maxW=Math.max(maxW,tmpCtx.measureText(line).width);});
    obj.width=maxW;
    obj.height=lines.length*obj.fontSize*1.2;
}

/* ═══════════════════════════════════════════════════════════════
   FLOOD FILL (Scanline)
   ═══════════════════════════════════════════════════════════════ */
function floodFill(startX,startY,color,opacity){
    var composite=makeCanvas(CANVAS_W,CANVAS_H);
    var cctx=composite.getContext('2d');
    cctx.drawImage(bgCanvas,0,0);
    cctx.drawImage(shapeCanvas,0,0);
    cctx.drawImage(objectCanvas,0,0);
    cctx.drawImage(drawCanvas,0,0);
    cctx.drawImage(pixelCanvas,0,0);
    var imgData=cctx.getImageData(0,0,CANVAS_W,CANVAS_H);
    var data=imgData.data;
    var w=CANVAS_W, h=CANVAS_H;

    if(startX<0||startY<0||startX>=w||startY>=h)return;

    var targetIdx=(startY*w+startX)*4;
    var tR=data[targetIdx], tG=data[targetIdx+1], tB=data[targetIdx+2], tA=data[targetIdx+3];

    var fR=parseInt(color.slice(1,3),16), fG=parseInt(color.slice(3,5),16), fB=parseInt(color.slice(5,7),16);
    var fA=Math.round(opacity*255);

    if(tR===fR&&tG===fG&&tB===fB&&tA===fA)return;

    var tolerance=30;
    function matches(i){
        return Math.abs(data[i]-tR)<=tolerance&&Math.abs(data[i+1]-tG)<=tolerance&&Math.abs(data[i+2]-tB)<=tolerance&&Math.abs(data[i+3]-tA)<=tolerance;
    }

    var fillData=drawCtx.getImageData(0,0,w,h);
    var fd=fillData.data;
    var visited=new Uint8Array(w*h);
    var stack=[[startX,startY]];

    while(stack.length){
        var pt=stack.pop();
        var px=pt[0], py=pt[1];
        while(px>0&&matches((py*w+px-1)*4)&&!visited[py*w+px-1])px--;
        var spanAbove=false, spanBelow=false;
        while(px<w&&matches((py*w+px)*4)&&!visited[py*w+px]){
            var fi=(py*w+px)*4;
            fd[fi]=fR;fd[fi+1]=fG;fd[fi+2]=fB;fd[fi+3]=fA;
            data[fi]=fR;data[fi+1]=fG;data[fi+2]=fB;data[fi+3]=fA;
            visited[py*w+px]=1;

            if(py>0){
                if(matches(((py-1)*w+px)*4)&&!visited[(py-1)*w+px]){
                    if(!spanAbove){stack.push([px,py-1]);spanAbove=true;}
                }else{spanAbove=false;}
            }
            if(py<h-1){
                if(matches(((py+1)*w+px)*4)&&!visited[(py+1)*w+px]){
                    if(!spanBelow){stack.push([px,py+1]);spanBelow=true;}
                }else{spanBelow=false;}
            }
            px++;
        }
    }

    drawCtx.putImageData(fillData,0,0);
}

/* ═══════════════════════════════════════════════════════════════
   EYEDROPPER
   ═══════════════════════════════════════════════════════════════ */
function pickColor(x,y){
    var composite=makeCanvas(CANVAS_W,CANVAS_H);
    var cctx=composite.getContext('2d');
    cctx.drawImage(bgCanvas,0,0);
    cctx.drawImage(shapeCanvas,0,0);
    cctx.drawImage(objectCanvas,0,0);
    cctx.drawImage(drawCanvas,0,0);
    cctx.drawImage(pixelCanvas,0,0);
    var px=cctx.getImageData(Math.round(x),Math.round(y),1,1).data;
    var hex='#'+((1<<24)+(px[0]<<16)+(px[1]<<8)+px[2]).toString(16).slice(1);
    setColor(hex);
}


/* ═══════════════════════════════════════════════════════════════
   ZOOM
   ═══════════════════════════════════════════════════════════════ */
function setZoom(z){
    zoomLevel=Math.max(0.25,Math.min(8,z));
    sizeDisplayCanvas();
    compositeAndRender();
    $('zoom-info').textContent=Math.round(zoomLevel*100)+' %';
}

function onWheel(e){
    if(!e.ctrlKey) return;
    e.preventDefault();
    var factor=e.deltaY<0?1.15:0.87;
    setZoom(zoomLevel*factor);
}

/* ═══════════════════════════════════════════════════════════════
   COLOR PALETTE + HSV PICKER (in filters)
   ═══════════════════════════════════════════════════════════════ */

function hsvToRgb(h,s,v){
    var c=v*s, x=c*(1-Math.abs((h/60)%2-1)), m=v-c;
    var r,g,b;
    if(h<60){r=c;g=x;b=0}else if(h<120){r=x;g=c;b=0}
    else if(h<180){r=0;g=c;b=x}else if(h<240){r=0;g=x;b=c}
    else if(h<300){r=x;g=0;b=c}else{r=c;g=0;b=x}
    return [Math.round((r+m)*255),Math.round((g+m)*255),Math.round((b+m)*255)];
}
function rgbToHsv(r,g,b){
    r/=255;g/=255;b/=255;
    var mx=Math.max(r,g,b),mn=Math.min(r,g,b),d=mx-mn;
    var h=0,s=mx===0?0:d/mx,v=mx;
    if(d!==0){
        if(mx===r)h=60*((g-b)/d%6);
        else if(mx===g)h=60*((b-r)/d+2);
        else h=60*((r-g)/d+4);
    }
    if(h<0)h+=360;
    return [h,s,v];
}
function rgbToHex(r,g,b){return '#'+[r,g,b].map(function(x){return x.toString(16).padStart(2,'0')}).join('');}
function hexToRgb(hex){
    hex=hex.replace('#','');
    if(hex.length===3)hex=hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    return [parseInt(hex.substr(0,2),16),parseInt(hex.substr(2,2),16),parseInt(hex.substr(4,2),16)];
}

/* ── Button palette (all tools) ── */
function buildPalette(){
    var html='';
    COLORS.forEach(function(c){
        html+='<div class="dw-color'+(c===activeColor?' active':'')+'" style="background:'+c+'" data-color="'+c+'"></div>';
    });
    $('palette').innerHTML=html;
    $('palette').querySelectorAll('.dw-color').forEach(function(el){
        el.onclick=function(){setColor(el.dataset.color);};
    });
    $('color-more-btn').onclick=function(){$('color-input').click();};
    $('color-input').oninput=function(){setColor(this.value);};
    // Click swatch to open native picker too
    $('cur-swatch').onclick=function(){$('color-input').click();};
    updateCurrentColor();
    buildRecentColors();
}

function updateCurrentColor(){
    $('cur-swatch').style.background=activeColor;
    $('cur-hex').textContent=activeColor.toUpperCase();
}

function setColor(c){
    activeColor=c;
    // Update palette buttons
    $('color-input').value=c;
    $('palette').querySelectorAll('.dw-color').forEach(function(el){
        el.classList.toggle('active',el.dataset.color===c);
    });
    updateCurrentColor();
    // Update live objects
    if(activeTextOverlay) activeTextOverlay.el.style.color=c;
    if(selectedObj&&activeTool==='select'){saveState();selectedObj.color=c;markDirty();}
    if(activeTool==='shapes'&&shapeMode){_shapeCursorCache={};updateCursor();}
}

/* ── Pre-filter snapshot (for non-destructive hue/filter) ── */
var filterSnapshot=null; // {draw:ImageData, shape:ImageData, objects:Array}

function saveFilterSnapshot(){
    // Flatten objects to drawCtx so filters apply to them too
    if(objects.length) flattenObjects();
    filterSnapshot={
        draw:drawCtx.getImageData(0,0,INTERNAL_SIZE,INTERNAL_SIZE),
        shape:shapeCtx.getImageData(0,0,INTERNAL_SIZE,INTERNAL_SIZE)
    };
}

function restoreFilterSnapshot(){
    if(!filterSnapshot)return;
    saveState();
    drawCtx.putImageData(filterSnapshot.draw,0,0);
    shapeCtx.putImageData(filterSnapshot.shape,0,0);
    filterSnapshot=null;
    markDirty();
}

/* ── Hue-rotate filter bar ──
   Filter button bindings (btn-invert / btn-reset-filter / hue-bar pointer
   handlers) attach at init time via bindFilterControls() so they are NEVER
   silent on click. The previous architecture bound them inside initHueBar()
   which returned early when hue-bar.clientWidth was 0 (panel not yet laid
   out on first measurement) — leaving Invert / Reset Filter unresponsive.
   Production telemetry: 13 silent_click events on btn-invert across 14d.
   drawHueGradient() runs lazily when the Filters panel becomes visible and
   is idempotent / safe to retry until the panel has real dimensions. */
var _hueGradientReady=false;
var _selectedHue=0;

function bindFilterControls(){
    var el=$('hue-bar');
    if(!el) return;
    var dragging=false;
    function hueUpdate(e){
        var r=el.getBoundingClientRect();
        if(!r.width) return;
        var ratio=Math.max(0,Math.min(1,((e.touches?e.touches[0].clientX:e.clientX)-r.left)/r.width));
        _selectedHue=Math.round(ratio*360);
        $('hue-bar-thumb').style.left=(ratio*100)+'%';
    }
    el.addEventListener('pointerdown',function(e){dragging=true;try{el.setPointerCapture(e.pointerId);}catch(_){}hueUpdate(e);});
    el.addEventListener('pointermove',function(e){if(dragging)hueUpdate(e);});
    el.addEventListener('pointerup',function(){if(dragging){dragging=false;applyColorize(_selectedHue);}});

    var bi=$('btn-invert');
    if(bi) bi.onclick=function(){
        if(objects.length) flattenObjects();
        applyPixelFilter(function(d,i){d[i]=255-d[i];d[i+1]=255-d[i+1];d[i+2]=255-d[i+2];});
    };

    var br=$('btn-reset-filter');
    if(br) br.onclick=restoreFilterSnapshot;
}

function drawHueGradient(){
    if(_hueGradientReady) return;
    var el=$('hue-bar'),c=$('hue-bar-canvas');
    if(!el||!c) return;
    var w=el.clientWidth,h=el.clientHeight;
    if(!w||!h) return; // Panel just toggled visible — let next frame settle layout
    c.width=w;c.height=h;
    var ctx=c.getContext('2d');
    var g=ctx.createLinearGradient(0,0,w,0);
    for(var i=0;i<=6;i++){
        var rgb=hsvToRgb(i*60,1,1);
        g.addColorStop(i/6,'rgb('+rgb[0]+','+rgb[1]+','+rgb[2]+')');
    }
    ctx.fillStyle=g;ctx.fillRect(0,0,w,h);
    _hueGradientReady=true;
}

function applyColorize(hue){
    // Save snapshot on first filter application; restore it on subsequent ones to prevent stacking
    if(!filterSnapshot){
        saveFilterSnapshot();
    }else{
        // Restore original data before re-applying
        drawCtx.putImageData(filterSnapshot.draw,0,0);
        shapeCtx.putImageData(filterSnapshot.shape,0,0);
    }
    saveState();
    [drawCtx,shapeCtx].forEach(function(ctx){
        var imgData=ctx.getImageData(0,0,CANVAS_W,CANVAS_H);
        var d=imgData.data;
        for(var i=0;i<d.length;i+=4){
            if(d[i+3]===0) continue;
            var lum=(d[i]*0.299+d[i+1]*0.587+d[i+2]*0.114)/255;
            var rgb=hsvToRgb(hue, 0.85, Math.max(0.05, lum));
            d[i]=rgb[0]; d[i+1]=rgb[1]; d[i+2]=rgb[2];
        }
        ctx.putImageData(imgData,0,0);
    });
    markDirty();
}

function addUsedColor(c){
    var idx=recentColors.indexOf(c);
    if(idx>-1)recentColors.splice(idx,1);
    recentColors.unshift(c);
    if(recentColors.length>6)recentColors.pop();
    buildRecentColors();
}

function buildRecentColors(){
    $('recent-colors').innerHTML=recentColors.map(function(c){
        return '<div class="dw-recent-dot" style="background:'+c+'" data-color="'+c+'"></div>';
    }).join('');
    $('recent-colors').querySelectorAll('.dw-recent-dot').forEach(function(el){
        el.onclick=function(){setColor(el.dataset.color);};
    });
}

/* ═══════════════════════════════════════════════════════════════
   TOOLBAR
   ═══════════════════════════════════════════════════════════════ */
function setupToolbar(){
    $('toolbar').querySelectorAll('.dw-tbtn[data-tool]').forEach(function(btn){
        btn.onclick=function(){
            var tool=btn.dataset.tool;
            var scrollY=window.scrollY;

            // Shapes toggle
            if(tool==='shapes'){
                var panel=$('shapes-panel');
                var isOpening=!panel.classList.contains('visible');
                panel.classList.toggle('visible');
                if(isOpening){
                    if(!shapesLoaded)loadShapes();
                    activeTool='shapes';
                }else{
                    activeTool='pencil';
                    shapeMode=null;
                }
                $('toolbar').querySelectorAll('.dw-tbtn[data-tool]').forEach(function(b){
                    b.classList.toggle('active', b.dataset.tool===activeTool || (b.dataset.tool==='shapes' && panel.classList.contains('visible')));
                });
                deselectObject();
                updateSidebarPanels();
                updateCursor();
                if(window.scrollY!==scrollY)window.scrollTo(0,scrollY);
                return;
            }

            // Commit pending
            if(activeTextOverlay){commitTextOverlay();}
            $('shapes-panel').classList.remove('visible');
            shapeMode=null;

            // If switching away from select, keep objects but deselect
            if(activeTool==='select'&&tool!=='select') deselectObject();

            activeTool=tool;
            // Flatten vector objects to raster before erasing
            if(tool==='eraser' && objects.length) flattenObjects();
            $('toolbar').querySelectorAll('.dw-tbtn[data-tool]').forEach(function(b){b.classList.remove('active')});
            btn.classList.add('active');
            updateSidebarPanels();
            updateCursor();
            if(window.scrollY!==scrollY)window.scrollTo(0,scrollY);
        };
    });
}

function updateCursor(){
    var area=$('canvas-area');
    if(activeTool==='select') area.style.cursor='default';
    else if(activeTool==='shapes'&&shapeMode) area.style.cursor=buildShapeCursor(shapeMode);
    else if(activeTool==='eyedropper')area.style.cursor='url("data:image/svg+xml,'+encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M2 22l1-1h3l9-9" stroke="%23fff" stroke-width="4"/><path d="M16 2l6 6-2 2-6-6 2-2z" stroke="%23fff" stroke-width="4"/><path d="M14 6l-8.5 8.5" stroke="%23fff" stroke-width="4"/><path d="M2 22l1-1h3l9-9" stroke="%23333" stroke-width="2"/><path d="M16 2l6 6-2 2-6-6 2-2z" stroke="%23333" stroke-width="2"/><path d="M14 6l-8.5 8.5" stroke="%23333" stroke-width="2"/></svg>')+'") 1 23, crosshair';
    else if(activeTool==='fill')area.style.cursor='cell';
    else if(activeTool==='text')area.style.cursor='text';
    else area.style.cursor='crosshair';
}

/* ── Build custom cursor from shape ── */
var _shapeCursorCache={};
function buildShapeCursor(shape){
    var key=shape.id+'_'+activeColor+'_'+brushSize;
    if(_shapeCursorCache[key]) return _shapeCursorCache[key];
    var sz=32;
    var c=makeCanvas(sz,sz);
    var ctx2=c.getContext('2d');
    var vb=(shape.viewBox||'0 0 100 100').split(' ').map(Number);
    var sc=sz/Math.max(vb[2],vb[3])*0.85;
    var ox=(sz-vb[2]*sc)/2, oy=(sz-vb[3]*sc)/2;
    ctx2.translate(ox,oy);
    ctx2.scale(sc,sc);
    ctx2.strokeStyle=activeColor;
    ctx2.lineWidth=2/sc;
    ctx2.lineCap='round';ctx2.lineJoin='round';
    (shape.paths||[]).forEach(function(pathStr){
        ctx2.stroke(new Path2D(pathStr));
    });
    var url=c.toDataURL('image/png');
    var cursor='url("'+url+'") 16 16, copy';
    _shapeCursorCache[key]=cursor;
    return cursor;
}

/* ── Context-aware sidebar ── */
function updateSidebarPanels(){
    var scrollY=window.scrollY;
    var usesSize=['pencil','brush','eraser','spray','line','shapes'].indexOf(activeTool)>-1;
    var el;
    if((el=$('size-opacity-panel')))el.style.display=usesSize?'':'none';
    if((el=$('text-panel')))el.classList.toggle('visible',activeTool==='text');
    if((el=$('filter-panel'))){el.classList.toggle('visible',activeTool==='filters');if(activeTool==='filters'){drawHueGradient();if(!_hueGradientReady)requestAnimationFrame(drawHueGradient);}}
    if((el=$('select-panel')))el.classList.toggle('visible',activeTool==='select');
    if((el=$('select-hint')))el.style.display=selectedObj?'none':'block';
    if((el=document.querySelector('.dw-sel-actions')))el.style.display=selectedObj?'grid':'none';
    if((el=$('sel-opacity-group'))){
        el.style.display=selectedObj?'':'none';
        if(selectedObj){
            var pct=Math.round((selectedObj.opacity||1)*100);
            $('sl-sel-opacity').value=pct;
            $('sel-opacity-val').textContent=pct+'%';
        }
    }
    if(window.scrollY!==scrollY)window.scrollTo(0,scrollY);
}

/* ═══════════════════════════════════════════════════════════════
   SELECT TOOL — SIDEBAR ACTIONS
   ═══════════════════════════════════════════════════════════════ */
function deleteSelectedObject(){
    if(!selectedObj) return;
    saveState();
    var idx=objects.indexOf(selectedObj);
    if(idx>-1) objects.splice(idx,1);
    deselectObject();
    markDirty();
}

function duplicateSelectedObject(){
    if(!selectedObj) return;
    saveState();
    var copy=JSON.parse(JSON.stringify(selectedObj));
    copy.id=nextObjId++;
    copy.x+=30; copy.y+=30;
    if(copy.type==='shape' && copy._shapeId){
        copy.shape=findShapeById(copy._shapeId)||selectedObj.shape;
    }else if(copy.type==='shape'){
        copy.shape=selectedObj.shape;
    }
    objects.push(copy);
    selectObject(copy);
    markDirty();
}

$('sel-rotate-cw').onclick=function(){
    if(!selectedObj)return;
    saveState();
    selectedObj.rotation=((selectedObj.rotation||0)+90)%360;
    renderSelection(); markDirty();
};
$('sel-rotate-ccw').onclick=function(){
    if(!selectedObj)return;
    saveState();
    selectedObj.rotation=((selectedObj.rotation||0)-90+360)%360;
    renderSelection(); markDirty();
};
$('sel-flip-h').onclick=function(){
    if(!selectedObj)return;
    saveState();
    selectedObj.flipH=!selectedObj.flipH;
    markDirty();
};
$('sel-flip-v').onclick=function(){
    if(!selectedObj)return;
    saveState();
    selectedObj.flipV=!selectedObj.flipV;
    markDirty();
};
$('sel-delete').onclick=deleteSelectedObject;
$('sel-duplicate').onclick=duplicateSelectedObject;
$('sl-sel-opacity').oninput=function(){
    if(!selectedObj)return;
    // «Undo» must bring back the opacity from BEFORE the drag: the step is taken at its
    // first move. Until 01.10.2026 it was taken on release — after the change — and
    // «Undo» restored the new value, i.e. did nothing.
    if(!this._undoTaken){this._undoTaken=true;saveState();}
    var v=parseInt(this.value,10);
    $('sel-opacity-val').textContent=v+'%';
    selectedObj.opacity=v/100;
    W.liveEdit=true;   // a slider in motion: saved as it moves, counted as an edit on release
    markDirty();
};
$('sl-sel-opacity').onchange=function(){this._undoTaken=false;draftLiveDone();};

/* ═══════════════════════════════════════════════════════════════
   TOP BAR ACTIONS
   ═══════════════════════════════════════════════════════════════ */
$('btn-undo').onclick=undo;
$('btn-redo').onclick=redo;

$('btn-clear').onclick=function(){
    if(!confirm(L.clearConfirm))return;
    saveState();
    drawCtx.clearRect(0,0,CANVAS_W,CANVAS_H);
    shapeCtx.clearRect(0,0,CANVAS_W,CANVAS_H);
    pixelCtx.clearRect(0,0,CANVAS_W,CANVAS_H);
    previewCtx.clearRect(0,0,CANVAS_W,CANVAS_H);
    objects=[];selectedObj=null;
    markDirty();
    updateSidebarPanels();
};

var _savedNames=[];
function _uniqueName(){
    var d=new Date();
    var pad=function(n){return n<10?'0'+n:''+n;};
    return 'drawing-'+d.getFullYear()+pad(d.getMonth()+1)+pad(d.getDate())+'-'+pad(d.getHours())+pad(d.getMinutes())+pad(d.getSeconds());
}
function _doSave(fname){
    var exp=makeCanvas(CANVAS_W,CANVAS_H);
    var ectx=exp.getContext('2d');
    ectx.drawImage(bgCanvas,0,0);
    ectx.drawImage(shapeCanvas,0,0);
    ectx.drawImage(objectCanvas,0,0);
    ectx.drawImage(drawCanvas,0,0);
    ectx.drawImage(pixelCanvas,0,0);
    exp.toBlob(function(blob){
        var url=URL.createObjectURL(blob);
        var a=document.createElement('a');
        a.href=url;a.download=fname+'.png';
        document.body.appendChild(a);a.click();document.body.removeChild(a);
        setTimeout(function(){URL.revokeObjectURL(url);},1000);
        var toast=$('save-toast');
        toast.classList.add('visible');
        setTimeout(function(){toast.classList.remove('visible');},2500);
        // the drawing went out as a file: in «My work» it is «downloaded», and a new
        // tab no longer reopens it by itself
        if(drafts)drafts.exported();
    },'image/png');
}
$('btn-save').onclick=function(){
    /* Mobile: save instantly, show feedback on button */
    if(window.innerWidth<=768){
        var btn=this;
        var fname=_uniqueName();
        _savedNames.push(fname);
        _doSave(fname);
        btn.classList.add('toggled');
        var orig=btn.innerHTML;
        btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>';
        setTimeout(function(){btn.innerHTML=orig;btn.classList.remove('toggled');},2000);
        return;
    }
    /* Desktop: show dialog */
    var overlay=$('save-overlay');
    var input=$('save-filename');
    var warn=$('save-warn');
    input.value=_uniqueName();
    if(warn)warn.style.display='none';
    overlay.classList.add('visible');
    setTimeout(function(){input.focus({preventScroll:true});input.select();},50);
};
$('save-cancel').onclick=function(){$('save-overlay').classList.remove('visible');};
$('save-overlay').onclick=function(e){if(e.target===this)this.classList.remove('visible');};
$('save-confirm').onclick=function(){
    var fname=($('save-filename').value||'drawing').replace(/[<>:"/\\|?*]/g,'');
    if(!fname)fname=_uniqueName();
    var warn=$('save-warn');
    if(_savedNames.indexOf(fname)>-1&&warn&&warn.style.display==='none'){
        warn.style.display='';
        warn.textContent=L.save_overwrite||'A file with this name was already saved. Click Save again to confirm.';
        return;
    }
    _savedNames.push(fname);
    if(warn)warn.style.display='none';
    $('save-overlay').classList.remove('visible');
    _doSave(fname);
};
$('save-filename').addEventListener('keydown',function(e){
    if(e.key==='Enter'){e.preventDefault();$('save-confirm').click();}
    if(e.key==='Escape'){e.preventDefault();$('save-cancel').click();}
});
$('save-filename').addEventListener('input',function(){
    var warn=$('save-warn');
    if(warn)warn.style.display='none';
});

$('btn-print').onclick=function(){
    var exp=makeCanvas(CANVAS_W,CANVAS_H);
    var ectx=exp.getContext('2d');
    ectx.drawImage(bgCanvas,0,0);
    ectx.drawImage(shapeCanvas,0,0);
    ectx.drawImage(objectCanvas,0,0);
    ectx.drawImage(drawCanvas,0,0);
    ectx.drawImage(pixelCanvas,0,0);
    var dataUrl=exp.toDataURL('image/png');
    var orient=CANVAS_W>=CANVAS_H?'landscape':'portrait';
    /* Печать зовёт ОТКРЫВШАЯ страница; инлайна в разметке попапа нет вовсе.
     * Попап наследует наш CSP, а обработчик в АТРИБУТЕ держится на
     * `script-src-attr 'unsafe-inline'` — директиве, которую реализовали не
     * все: Firefox её не знает и сверяет атрибут с `script-src`, где нонс
     * гасит 'unsafe-inline'. Поэтому onload="window.print()" резался молча, и
     * кнопка не печатала НИ РАЗУ у этой доли посетителей (отчёт
     * csp:first-party-alert 21.09.2026: script-src/inline ← js-min/drawing.js,
     * Firefox 104 — в шипнутом файле это был единственный атрибутный
     * обработчик). __printWindow ждёт `load` попапа — к нему картинка уже
     * загружена — и печатает из нашей страницы. */
    var win=window.__printWindow('<!DOCTYPE html><html><head><title>Print</title><style>@page{size:'+orient+'}body{margin:0;display:flex;align-items:center;justify-content:center;min-height:100vh}img{max-width:100%;max-height:100vh;height:auto}</style></head><body><img src="'+dataUrl+'"></body></html>',{
        onBlocked:function(){__toast(((window.__commonStrings||{}).ui_popup_blocked)||'Popup blocked','error');}
    });
    if(!win)return;
    /* Окно закрывалось прежним `window.close()` в том же атрибуте — сохраняем
     * это поведение, но СЛУШАТЕЛЕМ из открывшей страницы и по `afterprint`,
     * то есть когда диалог печати уже закрыт (прежний close() шёл сразу за
     * print()). Где afterprint не поддержан, окно просто останется открытым —
     * ровно так ведут себя остальные кнопки печати сайта. */
    try{win.addEventListener('afterprint',function(){try{win.close()}catch(_e){}});}catch(_e){}
    /* Датчика у кнопки не было вовсе — класс был нем по построению: отказ
     * виден только в отчёте CSP. tool_complete не трогаем, им в блейде владеет
     * «Сохранить» со своим замком _ptDone. */
    if(window.__ae)window.__ae('feature_use',{action:'print'});
};

/* ── Orientation select ── */
$('sel-orientation').onchange=function(){
    var wantLandscape=this.value==='landscape';
    var isLandscape=CANVAS_W>=CANVAS_H;
    if(wantLandscape===isLandscape)return;
    // Just swap logical dimensions — off-screen canvases are INTERNAL_SIZE x INTERNAL_SIZE so no data is lost
    var tmp=CANVAS_W;CANVAS_W=CANVAS_H;CANVAS_H=tmp;
    sizeDisplayCanvas();
    markDirty();
    undoStack=[];redoStack=[];updateUndoButtons();
};

/* ── Pixel mode toggle ── */
$('btn-pixel').onclick=function(){
    pixelMode=!pixelMode;
    this.classList.toggle('toggled',pixelMode);
    $('pixel-panel').style.display=pixelMode?'':'none';
    if(pixelMode)saveState();
    markDirty();
};

$('pixel-grid-size').onchange=function(){
    pixelGridSize=parseInt(this.value);
    markDirty();
};

$('btn-pixel-clear').onclick=function(){
    saveState();
    pixelCtx.clearRect(0,0,CANVAS_W,CANVAS_H);
    markDirty();
};

/* ── Size/opacity sliders ── */
$('sl-size').oninput=function(){
    brushSize=parseInt(this.value);
    $('size-val').textContent=brushSize+'px';
    if(activeTool==='shapes'&&shapeMode){_shapeCursorCache={};updateCursor();}
};
$('sl-opacity').oninput=function(){
    brushOpacity=parseInt(this.value)/100;
    $('opacity-val').textContent=this.value+'%';
};

/* ── Text tool panel ── */
$('sl-font-size').oninput=function(){
    $('font-size-val').textContent=this.value+'px';
    if(activeTextOverlay){
        var scaleY=displayCanvas.getBoundingClientRect().height/CANVAS_H;
        activeTextOverlay.fs=parseInt(this.value);
        activeTextOverlay.el.style.fontSize=Math.round(activeTextOverlay.fs*scaleY)+'px';
        /* Re-focus the text overlay so user can keep typing */
        activeTextOverlay.el.focus({preventScroll:true});
    }
};
$('text-font').onchange=function(){
    if(activeTextOverlay){
        activeTextOverlay.ff=this.value;
        activeTextOverlay.el.style.fontFamily=this.value;
        activeTextOverlay.el.focus({preventScroll:true});
    }
};
$('sl-text-opacity').oninput=function(){
    textOpacity=parseInt(this.value)/100;
    $('text-opacity-val').textContent=this.value+'%';
    if(activeTextOverlay){
        activeTextOverlay.el.style.opacity=textOpacity;
    }
};

/* ── Zoom bar ── */
$('zoom-in-btn').onclick=function(){setZoom(zoomLevel*1.25);};
$('zoom-out-btn').onclick=function(){setZoom(zoomLevel*0.8);};
$('zoom-reset-btn').onclick=function(){setZoom(1);};

/* ── Filters ── */
function applyPixelFilter(fn){
    saveState();
    filterSnapshot=null; // destructive filter — invalidate snapshot
    [drawCtx,shapeCtx].forEach(function(ctx){
        var imgData=ctx.getImageData(0,0,CANVAS_W,CANVAS_H);
        var d=imgData.data;
        for(var i=0;i<d.length;i+=4){if(d[i+3]>0) fn(d,i);}
        ctx.putImageData(imgData,0,0);
    });
    markDirty();
}

/* ── Fullscreen ── */
$('btn-fullscreen').onclick=function(){
    var app=$('dw-app');
    /* Through the core's doors: a prefixed method (iPad Safari before 16.4)
       returns undefined, not a Promise, and `.call(…).catch` on it threw — on
       the way in and on the way out — so the canvas resize below never ran
       (TIMBRICA-FRONTEND-NQ, iPad iOS 12). No Fullscreen API at all (iPhone)
       keeps the CSS-only fullscreen, as before. */
    if(app.classList.contains('fullscreen')){
        app.classList.remove('fullscreen');
        if(window.__safeExitFullscreen)window.__safeExitFullscreen();
    }else{
        app.classList.add('fullscreen');
        if(window.__safeFullscreen)window.__safeFullscreen(app);
    }
    setTimeout(function(){sizeDisplayCanvas();compositeAndRender();},100);
};
['fullscreenchange','webkitfullscreenchange'].forEach(function(ev){document.addEventListener(ev,function(){
    if(!document.fullscreenElement&&!document.webkitFullscreenElement) $('dw-app').classList.remove('fullscreen');
    setTimeout(function(){sizeDisplayCanvas();compositeAndRender();},100);
});});

/* ═══════════════════════════════════════════════════════════════
   SHAPE CATALOG
   ═══════════════════════════════════════════════════════════════ */
var shapesLoaded=false;
var activeShapeCategory='animals';

function loadShapes(){
    if(typeof window.__DRAWING_SHAPES==='undefined'){
        var s=document.createElement('script');
        s.src='/js/drawing-shapes.js?v='+(__DW.SHAPES_V||1);
        s.onload=function(){shapesLoaded=true;renderShapeTabs();renderShapeGrid();};
        s.onerror=function(){__toast(L.errShapesLoad||'Failed to load shapes','error');};
        document.head.appendChild(s);
    }else{
        shapesLoaded=true;
        renderShapeTabs();
        renderShapeGrid();
    }
}

function renderShapeTabs(){
    var cats=Object.keys(window.__DRAWING_SHAPES||{});
    $('shapes-tabs').innerHTML=cats.map(function(cat){
        return '<button class="dw-shapes-tab'+(cat===activeShapeCategory?' active':'')+'" data-cat="'+cat+'">'+(SHAPE_CATS[cat]||cat)+'</button>';
    }).join('');
    $('shapes-tabs').querySelectorAll('.dw-shapes-tab').forEach(function(tab){
        tab.onclick=function(){
            activeShapeCategory=tab.dataset.cat;
            $('shapes-tabs').querySelectorAll('.dw-shapes-tab').forEach(function(t){t.classList.remove('active')});
            tab.classList.add('active');
            renderShapeGrid();
        };
    });
}

function renderShapeGrid(){
    var shapes=(window.__DRAWING_SHAPES||{})[activeShapeCategory]||[];
    $('shapes-grid').innerHTML=shapes.map(function(s,i){
        var name=SHAPE_NAMES[s.id]||s.id;
        return '<div class="dw-shape-card'+(shapeMode&&shapeMode.id===s.id?' active':'')+'" data-idx="'+i+'" title="'+name+'"><canvas width="56" height="56"></canvas></div>';
    }).join('');
    $('shapes-grid').querySelectorAll('.dw-shape-card').forEach(function(card,i){
        var s=shapes[i];
        var c=card.querySelector('canvas');
        var ctx2=c.getContext('2d');
        drawShapeOnCanvas(ctx2,s,56,56);
        card.onclick=function(){
            if(shapeMode&&shapeMode.id===s.id){
                shapeMode=null;
                card.classList.remove('active');
                activeTool='pencil';
                $('toolbar').querySelectorAll('.dw-tbtn[data-tool]').forEach(function(b){b.classList.toggle('active',b.dataset.tool==='pencil')});
            }else{
                shapeMode=s;
                activeTool='shapes';
                $('shapes-grid').querySelectorAll('.dw-shape-card').forEach(function(c2){c2.classList.remove('active')});
                card.classList.add('active');
                _shapeCursorCache={};
            }
            updateCursor();
        };
    });
}

function drawShapeOnCanvas(ctx2,shape,w,h){
    ctx2.clearRect(0,0,w,h);
    var vb=(shape.viewBox||'0 0 100 100').split(' ').map(Number);
    var sx=w/vb[2]*0.85, sy=h/vb[3]*0.85;
    var s=Math.min(sx,sy);
    var ox=(w-vb[2]*s)/2, oy=(h-vb[3]*s)/2;
    ctx2.save();
    ctx2.translate(ox,oy);
    ctx2.scale(s,s);
    ctx2.strokeStyle='var(--text-primary)';
    ctx2.lineWidth=2/s;
    ctx2.lineCap='round';ctx2.lineJoin='round';
    (shape.paths||[]).forEach(function(pathStr){
        var p2=new Path2D(pathStr);
        ctx2.stroke(p2);
    });
    ctx2.restore();
}

function placeShapeDirectly(x,y){
    if(!shapeMode)return;
    saveState();
    var sz=Math.max(80,brushSize*8);
    var obj={
        id:nextObjId++, type:'shape',
        x:x, y:y,
        shape:shapeMode, _shapeId:shapeMode.id,
        color:activeColor, opacity:brushOpacity, size:sz,
        rotation:0, flipH:false, flipV:false
    };
    objects.push(obj);
    addUsedColor(activeColor);
    // Stay in shapes mode so user can place more shapes
    selectObject(obj);
    markDirty();
}

/* ═══════════════════════════════════════════════════════════════
   THE WORK SURVIVES A CRASH, A CLOSED TAB AND F5
   ═══════════════════════════════════════════════════════════════
   Audit of 30.09.2026: the drawing lived in memory only — a crash, a closed tab or
   F5 left a white sheet. The shared «my work» controller (tool-draft-editor.js over
   tool-draft.js, IndexedDB in the `work` bucket of work-storage.js) keeps it; this
   part says what the work IS, how it comes back and what a new one looks like.

   The work: the three layers as PNG (a blank layer as no picture), the editable
   objects (catalog shapes WITH their paths — the catalog script may not be loaded
   when a drawing comes back — and texts), the sheet (orientation, the square the
   layers live in), pixel mode and its grid, the colours in use. The background is
   white by construction (the eraser paints white on white) and is not saved.

   Encoding: once a change has settled (stroke end, fill, shape placed, text
   committed, clear, undo/redo, filter…) the change is counted (touch) and the
   layers it touched go to toBlob; when the PNGs are ready they are kept and the
   save is asked for again. The state and the pixels are kept as a PAIR taken at
   the same moment, so a save never pairs new objects with old pixels (a fill
   flattens the objects INTO the pixels). payload() hands over the latest complete
   pair — null only while the very first encoding runs — and never encodes itself:
   Chrome encodes a PNG on the main thread, so that would stall the next stroke.
   Only when the page is about to lose its chance — hidden, going away, the «my
   work» bar about to write it before «New» or another drawing, the hand-off to
   /ar-drawing — are the layers still being encoded done synchronously
   (draftSettle), and never in the middle of a stroke. Measured 30.09.2026,
   Chrome 154 on a loaded machine: one 1200² layer 16 ms blank, 25–37 ms a
   drawing, 65 ms a sheet covered in spray; decoding it back 15–30 ms. */
var drafts=null;
var W={
    gen:0,          // bumped by «New» / an opened work: encodings of the former one are dropped
    seq:0,          // order of the kept pictures: an older encoding never replaces a newer one
    snap:null,      // {seq, state, key, revs, files:{draw,shape,pixel}} — the latest complete pair
    seen:null,      // {key, revs} of the page at the last check: equal = nothing changed
    queued:false, leaveBound:false,
    liveEdit:false, liveCounted:true,
    preview:'', previewAt:0
};

function revsNow(){return {draw:layerRev.draw,shape:layerRev.shape,pixel:layerRev.pixel};}
function sameRevs(a,b){return !!a&&!!b&&a.draw===b.draw&&a.shape===b.shape&&a.pixel===b.pixel;}

/* The work apart from its pixels. The colours in use travel with it (payload) but
   picking a colour is not an edit. */
function workState(){
    return {w:CANVAS_W,h:CANVAS_H,size:INTERNAL_SIZE,objects:saveObjectsSnapshot(),nextId:nextObjId,
        pixel:{on:pixelMode,grid:pixelGridSize}};
}

function queueCommit(){
    if(!drafts||W.queued)return;
    W.queued=true;
    Promise.resolve().then(function(){W.queued=false;commitCheck();});
}

/* A change has settled: was it a change of the work? Then count it and start
   encoding the layers it touched. Selecting, deselecting and every markDirty in the
   middle of a stroke reach here too, and change nothing. */
function commitCheck(){
    if(!drafts||!drafts.live()||isDrawing)return;
    var st=workState(),key=JSON.stringify(st),revs=revsNow();
    var live=W.liveEdit;W.liveEdit=false;
    if(W.seen&&W.seen.key===key&&sameRevs(W.seen.revs,revs))return;
    W.seen={key:key,revs:revs};
    var base=W.snap,seq=++W.seq,gen=W.gen;
    var need=LAYER_KEYS.filter(function(k){return !base||base.revs[k]!==revs[k];});
    if(!need.length){
        W.snap={seq:seq,state:st,key:key,revs:revs,files:base.files};
    }else{
        encodeAsync(need).then(function(got){
            // a newer picture is kept already, or another work is on the page by now
            if(!got||gen!==W.gen||(W.snap&&W.snap.seq>=seq))return;
            var files={};
            LAYER_KEYS.forEach(function(k){files[k]=got.hasOwnProperty(k)?got[k]:base.files[k];});
            W.snap={seq:seq,state:st,key:key,revs:revs,files:files};
            // the pixels of this change exist now: save again (the change itself was
            // counted when it happened — true here would count it twice)
            drafts.touch(false);
        });
    }
    if(live)W.liveCounted=false;
    drafts.touch(!live);
    if(drafts.id())bindLeave();
}

/* The page is about to lose its chance to save (hidden, going away, the «my work»
   bar writing it before «New» or another drawing, the hand-off): whatever is still
   being encoded is encoded now, and the save that follows carries it. Never in the
   middle of a stroke — that stroke is not part of the drawing yet. → true when the
   drawing on the page is now newer than what the store was about to write. */
function draftSettle(){
    if(!drafts||!drafts.live()||isDrawing)return false;
    var s=W.snap,st=workState(),key=JSON.stringify(st),revs=revsNow();
    if(s&&s.key===key&&sameRevs(s.revs,revs))return false;
    try{
        var fs={};
        LAYER_KEYS.forEach(function(k){fs[k]=(s&&s.revs[k]===revs[k])?s.files[k]:encodeSync(k);});
        W.snap={seq:++W.seq,state:st,key:key,revs:revs,files:fs};
    }catch(e){return false;}             // out of memory, say: the last complete pair stands
    drafts.touch(false);                 // a save may have gone out with the pair before this one
    return true;
}

/* Going away (F5, a closed tab, a navigation). The store's own last write goes FIRST —
   the latest complete pair, at once — and only then are the layers still being encoded
   finished here and written after it. A page that is going away gets little time:
   measured 01.10.2026 (Chrome 154, a page left for about:blank), a pagehide listener
   ran ~180 ms at normal speed and under 10 ms at CPU ×40. Leaving 50 ms after a
   stroke kept the stroke 2 of 2 times at ×1, 1 of 2 at ×4, 0 of 1 at ×8 — and every
   time the drawing up to the stroke before came back. With the encoding done first,
   a teardown in the middle of it lost the last change AND everything since the
   previous save. Listeners run in the order they were added, so this one is added
   once this page holds a work — tool-draft.js has bound its own by then (claim). The
   write is unguarded (lastGasp): its conflict check needs a read the page never gets
   back, and this page is the one that was drawing a moment ago. */
function bindLeave(){
    if(W.leaveBound)return;
    W.leaveBound=true;
    window.addEventListener('pagehide',draftWriteNow);
}
/* The pixels were just brought up to date: write them at once, unguarded, rather than
   leave it to the flush that follows (the store's on hide, the bar's before «New» or
   another drawing). That flush is guarded — it reads the record first and gives up if
   the record is newer than this page last saw — and a guarded save started while
   another guarded save of the same page is in flight takes that save's write for
   another tab's: measured 01.10.2026, two back-to-back guarded saves → the second
   {ok:false, why:'foreign'}, and the controller forks or drops it (stand, step C at
   CPU ×40: the stroke made right before «New» went missing). An unguarded write queues
   behind the one in flight and lands after it. It is only ever issued when this tab
   changed the drawing a moment ago — the reason tool-draft.js gives for the last write
   of a page that goes away. */
function draftWriteNow(){
    if(!draftSettle())return;
    var S=drafts.store&&drafts.store();
    if(S)S.flush({lastGasp:true});
}
/* The slider let go: the change it made counts as one edit. */
function draftLiveDone(){
    if(drafts&&!W.liveCounted){W.liveCounted=true;drafts.touch(true);}
}

function layerFile(b,k){
    try{return new File([b],'drawing-'+k+'.png',{type:'image/png'});}catch(_){return b;}
}
/* → Promise<{key: File|null}> or null when an encoding failed (the previous pair stays). */
function encodeAsync(keys){
    return Promise.all(keys.map(function(k){
        if(layerBlank[k])return Promise.resolve([k,null]);
        return new Promise(function(res){
            try{LAYER_CANVAS[k].toBlob(function(b){res([k,b?layerFile(b,k):undefined]);},'image/png');}
            catch(_){res([k,undefined]);}
        });
    })).then(function(rs){
        var out={};
        for(var i=0;i<rs.length;i++){if(rs[i][1]===undefined)return null;out[rs[i][0]]=rs[i][1];}
        return out;
    });
}
function encodeSync(k){
    if(layerBlank[k])return null;
    var u=LAYER_CANVAS[k].toDataURL('image/png');
    var bin=atob(u.slice(u.indexOf(',')+1)),n=bin.length,a=new Uint8Array(n);
    for(var i=0;i<n;i++)a[i]=bin.charCodeAt(i);
    return layerFile(new Blob([a],{type:'image/png'}),k);
}

function draftPayload(){
    var s=W.snap;
    if(!s)return null;          // the very first encoding still runs: the previous save stands
    var files=[],layers={},ss=s.state;
    LAYER_KEYS.forEach(function(k){var f=s.files[k];if(f){layers[k]=files.length;files.push(f);}else layers[k]=-1;});
    return {
        state:{w:ss.w,h:ss.h,size:ss.size,objects:ss.objects,nextId:ss.nextId,pixel:ss.pixel,
            layers:layers,color:activeColor,recent:recentColors.slice()},
        files:files,
        label:draftLabel(ss.objects),
        preview:draftPreview(),
        meta:{w:ss.w,h:ss.h,objects:ss.objects.length,pixel:ss.pixel.on?1:0}
    };
}

/* What a person calls a drawing: the text written on it, else the pictures put on it. */
function draftLabel(objs){
    var i,o,names=[];
    for(i=0;i<objs.length;i++){
        o=objs[i];
        if(o.type!=='text')continue;
        var line=String(o.text||'').split('\n').map(function(s){return s.trim();}).filter(Boolean)[0];
        if(line)return line.slice(0,80);
    }
    for(i=0;i<objs.length&&names.length<3;i++){
        o=objs[i];
        var nm=o.type==='shape'?(SHAPE_NAMES[o._shapeId]||''):'';
        if(nm&&names.indexOf(nm)<0)names.push(nm);
    }
    return names.join(', ');
}

/* A small picture of the sheet for the list — the layers as compositeAndRender stacks
   them, without the selection frame and the pixel grid. */
function draftPreview(){
    var now=Date.now();
    if(W.preview&&now-W.previewAt<1500)return W.preview;
    try{
        var k=160/Math.max(CANVAS_W,CANVAS_H);
        var c=makeCanvas(Math.max(1,Math.round(CANVAS_W*k)),Math.max(1,Math.round(CANVAS_H*k))),x=c.getContext('2d');
        x.fillStyle='#ffffff';x.fillRect(0,0,c.width,c.height);
        x.drawImage(shapeCanvas,0,0,CANVAS_W,CANVAS_H,0,0,c.width,c.height);
        x.drawImage(drawCanvas,0,0,CANVAS_W,CANVAS_H,0,0,c.width,c.height);
        x.save();x.scale(c.width/CANVAS_W,c.height/CANVAS_H);
        objects.forEach(function(o){renderOneObject(x,o);});
        x.restore();
        x.drawImage(pixelCanvas,0,0,CANVAS_W,CANVAS_H,0,0,c.width,c.height);
        W.preview=c.toDataURL('image/jpeg',0.72);W.previewAt=now;
    }catch(_){/* a row without a picture still opens the drawing */}
    return W.preview;
}

/* The sheet the layers live in: a square of `size` (see initCanvas), cleared, the
   background white. Setting a canvas's size clears it without a context call, so the
   revisions are bumped by hand. */
function resizeLayers(size){
    INTERNAL_SIZE=size;
    [bgCanvas,shapeCanvas,drawCanvas,pixelCanvas,previewCanvas,objectCanvas,strokeCanvas].forEach(function(c){c.width=size;c.height=size;});
    bgCtx.fillStyle='#ffffff';bgCtx.fillRect(0,0,size,size);
    LAYER_KEYS.forEach(function(k){layerRev[k]++;layerBlank[k]=true;});
}
/* Whatever the hand was doing belongs to the drawing that is leaving the page:
   an unfinished stroke, a drag, a text still being typed. */
function dropInteraction(){
    if(activeTextOverlay){try{(activeTextOverlay.wrap||activeTextOverlay.el).remove();}catch(_){}activeTextOverlay=null;}
    isDrawing=false;dragState=null;drawStart=null;points=[];strokeOpacity=1;isPanning=false;touchCount=0;
}
function paintPixelUi(){
    $('btn-pixel').classList.toggle('toggled',pixelMode);
    $('pixel-panel').style.display=pixelMode?'':'none';
    $('pixel-grid-size').value=String(pixelGridSize);
}
/* Undo history starts at the drawing as it now is: «Undo» never steps back to the
   sheet that was on the page before it (for a restored drawing — an empty one). */
function freshHistory(){
    filterSnapshot=null;undoStack=[];redoStack=[];updateUndoButtons();
}
function settleSheet(){
    $('sel-orientation').value=CANVAS_W>=CANVAS_H?'landscape':'portrait';
    sizeDisplayCanvas();updateSidebarPanels();markDirty();
}
/* The page as it is now is what the work holds: nothing to save until the next change. */
function draftBaseline(files){
    var st=workState(),revs=revsNow();
    W.gen++;
    W.snap=files?{seq:++W.seq,state:st,key:JSON.stringify(st),revs:revs,files:files}:null;
    W.seen={key:JSON.stringify(st),revs:revs};
    W.liveEdit=false;W.liveCounted=true;
}

function decodeLayer(f){
    function viaImg(){
        return new Promise(function(res,rej){
            var u=URL.createObjectURL(f),im=new Image();
            im.onload=function(){URL.revokeObjectURL(u);res(im);};
            im.onerror=function(){URL.revokeObjectURL(u);rej(new Error('layer decode'));};
            im.src=u;
        });
    }
    if(typeof createImageBitmap==='function')return createImageBitmap(f).catch(viaImg);
    return viaImg();
}
function isHex(c){return typeof c==='string'&&/^#[0-9a-f]{6}$/i.test(c);}

/* Put a saved drawing back. → the names of layers whose picture did not come back. */
function draftApply(d){
    var st=d.state||{},files=d.files||[],lay=st.layers||{};
    // decoded first, swapped in at once: no frame shows half a drawing
    return Promise.all(LAYER_KEYS.map(function(k){
        var i=lay[k];
        if(typeof i!=='number'||i<0)return {k:k};
        var f=files[i];
        if(!f)return {k:k,missing:true};
        return decodeLayer(f).then(function(img){return {k:k,img:img,file:f};},function(){return {k:k,missing:true};});
    })).then(function(rs){
        dropInteraction();
        CANVAS_W=+st.w||CANVAS_W;CANVAS_H=+st.h||CANVAS_H;
        resizeLayers(Math.max(+st.size||0,CANVAS_W,CANVAS_H));
        var missing=[],kept={};
        rs.forEach(function(r){
            kept[r.k]=null;
            if(r.img){
                LAYER_CTX[r.k].drawImage(r.img,0,0);
                if(r.img.close)r.img.close();
                kept[r.k]=r.file;       // the restored pixels ARE these bytes
            }else if(r.missing)missing.push('layer-'+r.k);
        });
        // objects stay objects — movable, turnable, recolourable as before
        var objs=Array.isArray(st.objects)?JSON.parse(JSON.stringify(st.objects)):[];
        objs=objs.filter(function(o){return o&&(o.type==='text'||(o.type==='shape'&&(o.shape||findShapeById(o._shapeId))));});
        restoreObjectsSnapshot(objs);
        nextObjId=Math.max(+st.nextId||1,objs.reduce(function(m,o){return Math.max(m,+o.id||0);},0)+1);
        pixelMode=!!(st.pixel&&st.pixel.on);
        var g=st.pixel?+st.pixel.grid:64;
        pixelGridSize=[16,24,32,48,64].indexOf(g)>=0?g:64;
        paintPixelUi();
        if(Array.isArray(st.recent)){recentColors=st.recent.filter(isHex).slice(0,6);buildRecentColors();}
        if(isHex(st.color))setColor(st.color);
        freshHistory();
        settleSheet();
        draftBaseline(kept);
        W.preview=d.preview||'';W.previewAt=0;
        return missing;
    });
}

/* A new drawing: the sheet as the page opens it — white, landscape on a wide screen
   and portrait on a narrow one, no objects, pixel mode off, an empty undo history.
   The colours, the tool and the zoom stay: they belong to the hand, not the drawing. */
function draftFresh(){
    dropInteraction();
    var narrow=window.innerWidth<=768;
    CANVAS_W=narrow?600:1200;CANVAS_H=800;
    resizeLayers(Math.max(CANVAS_W,CANVAS_H));
    objects=[];nextObjId=1;selectedObj=null;
    pixelMode=false;pixelGridSize=64;paintPixelUi();
    freshHistory();
    settleSheet();
    draftBaseline(null);
    W.preview='';W.previewAt=0;
}

/* Something drawn on this page load: an unfinished drawing from before does not
   replace it on arrival. */
function draftStarted(){
    return isDrawing||!!activeTextOverlay||undoStack.length>0||redoStack.length>0||objects.length>0
        ||(layerRev.draw+layerRev.shape+layerRev.pixel)>0;
}

function draftsBoot(){
    var bar=$('dwDrafts');
    if(!bar)return;
    if(!window.__toolDraft||!window.__toolDraft.editor){
        // no store on this page — no bar that does nothing
        var wrap=bar.closest('.dw-drafts');if(wrap)wrap.hidden=true;
        return;
    }
    drafts=window.__toolDraft.editor({
        slug:'drawing',root:'dwDrafts',icon:'🎨',
        payload:draftPayload,apply:draftApply,fresh:draftFresh,started:draftStarted
    });
    W.seen={key:JSON.stringify(workState()),revs:revsNow()};
    // Hidden: ahead of the store's own flush on hide (tool-draft.js binds it on the
    // first save, later than this), which then finds nothing left to write.
    document.addEventListener('visibilitychange',function(){if(document.visibilityState==='hidden')draftWriteNow();});
    // «New», «My work», a row of the list: the bar writes the drawing on the page
    // before it gives way — capture phase, so the pixels are written first.
    document.addEventListener('click',function(e){
        var t=e.target;
        if(t&&t.closest&&t.closest('#dwDrafts,#dwDraftsNote'))draftWriteNow();
    },true);
    drafts.boot();
    // Leaving for /ar-drawing (the blade hands the canvas over and navigates): the
    // drawing is written now, unguarded like the store's own last write of a page
    // that is going away; coming back to /drawing in this tab reopens it.
    var trace=$('btn-trace');
    if(trace)trace.addEventListener('click',function(){
        var S=drafts.store&&drafts.store();
        if(!S)return;
        draftSettle();
        S.flush({lastGasp:true});
    });
}

/* ═══════════════════════════════════════════════════════════════
   WINDOW RESIZE
   ═══════════════════════════════════════════════════════════════ */
var resizeTimer;
window.addEventListener('resize',function(){
    clearTimeout(resizeTimer);
    resizeTimer=setTimeout(function(){sizeDisplayCanvas();compositeAndRender();},100);
});

/* ═══════════════════════════════════════════════════════════════
   INIT
   ═══════════════════════════════════════════════════════════════ */
initCanvas();
buildPalette();
setupToolbar();
setupDrawing();
bindFilterControls(); // Filter buttons bind unconditionally — no lazy silent-click trap
updateUndoButtons();
updateSidebarPanels();
draftsBoot();         // after the page's own start: the controller may reopen a drawing onto it

})();
});
